(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bars = document.querySelectorAll('[data-ph-announce]');
  bars.forEach(function (bar) {
    var toggle = bar.querySelector('[data-ph-announce-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var paused = bar.hasAttribute('data-ph-paused');
      if (paused) {
        bar.removeAttribute('data-ph-paused');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', 'Pause scrolling announcements');
      } else {
        bar.setAttribute('data-ph-paused', '');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', 'Resume scrolling announcements');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  // The marquee and the control's visibility are pure CSS. JS only wires the
  // quiet pause toggle. Idempotent, and re-run for sections the theme editor
  // injects via shopify:section:load (the global block does not re-run for those).
  function wire(scope) {
    (scope || document).querySelectorAll('[data-ph-fp-carousel]').forEach(function (root) {
      var toggle = root.querySelector('[data-ph-fp-pause]');
      if (!toggle || toggle.dataset.phWired) return;
      toggle.dataset.phWired = '1';
      toggle.addEventListener('click', function () {
        if (root.hasAttribute('data-ph-paused')) {
          root.removeAttribute('data-ph-paused');
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', 'Pause auto-rotation');
        } else {
          root.setAttribute('data-ph-paused', '');
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', 'Resume auto-rotation');
        }
      });
    });
  }
  wire(document);
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.getElementById('ph-header');
  if (!header) return;

  /* Sticky shrink/darken on scroll */
  var sticky = header.getAttribute('data-sticky') !== 'false';
  if (sticky) {
    var ticking = false;
    var applyStuck = function () {
      if (window.scrollY > 60) {
        header.classList.add('ph-header--stuck');
      } else {
        header.classList.remove('ph-header--stuck');
      }
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(applyStuck);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    applyStuck();
  }

  /* Desktop Shop mega-menu: real disclosure for keyboard + click */
  var megaItem = header.querySelector('[data-ph-mega]');
  var megaToggle = header.querySelector('[data-ph-mega-toggle]');
  var megaPanel = document.getElementById('ph-mega-panel');

  var openMega = function () {
    if (!megaItem || !megaToggle) return;
    megaItem.classList.add('is-open');
    megaToggle.setAttribute('aria-expanded', 'true');
  };
  var closeMega = function (returnFocus) {
    if (!megaItem || !megaToggle) return;
    megaItem.classList.remove('is-open');
    megaToggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) megaToggle.focus();
  };
  if (megaToggle) {
    megaToggle.addEventListener('click', function () {
      if (megaItem.classList.contains('is-open')) {
        closeMega(false);
      } else {
        openMega();
      }
    });
    megaToggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega();
        if (megaPanel) {
          var firstLink = megaPanel.querySelector('a[href]');
          if (firstLink) firstLink.focus();
        }
      }
    });
  }
  if (megaItem) {
    /* Hover intent: open on pointer enter, close on leave after a short delay so
       the cursor can cross the gap from the Shop trigger down into the panel
       without the menu collapsing. Pointer-capable devices only. */
    var megaHoverTimer;
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      megaItem.addEventListener('mouseenter', function () {
        window.clearTimeout(megaHoverTimer);
        openMega();
      });
      megaItem.addEventListener('mouseleave', function () {
        megaHoverTimer = window.setTimeout(function () { closeMega(false); }, 220);
      });
    }
    /* Escape closes the mega and returns focus to the Shop trigger */
    megaItem.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && megaItem.classList.contains('is-open')) {
        e.preventDefault();
        closeMega(true);
      }
    });
    /* Clicking or focusing outside closes it */
    document.addEventListener('focusin', function (e) {
      if (megaItem.classList.contains('is-open') && !megaItem.contains(e.target)) {
        closeMega(false);
      }
    });
    document.addEventListener('click', function (e) {
      if (megaItem.classList.contains('is-open') && !megaItem.contains(e.target)) {
        closeMega(false);
      }
    });
  }

  /* Guides dropdown: same disclosure model as the mega (click, ArrowDown, hover
     intent on pointer devices, Escape to close, outside click/focus closes). */
  var dropItem = header.querySelector('[data-ph-dropdown]');
  var dropToggle = header.querySelector('[data-ph-dropdown-toggle]');
  var dropPanel = document.getElementById('ph-guides-panel');
  if (dropItem && dropToggle) {
    var openDrop = function () { dropItem.classList.add('is-open'); dropToggle.setAttribute('aria-expanded', 'true'); };
    var closeDrop = function (returnFocus) { dropItem.classList.remove('is-open'); dropToggle.setAttribute('aria-expanded', 'false'); if (returnFocus) dropToggle.focus(); };
    dropToggle.addEventListener('click', function () {
      if (dropItem.classList.contains('is-open')) { closeDrop(false); } else { openDrop(); }
    });
    dropToggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openDrop();
        if (dropPanel) { var first = dropPanel.querySelector('a[href]'); if (first) first.focus(); }
      }
    });
    var dropHoverTimer;
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      dropItem.addEventListener('mouseenter', function () { window.clearTimeout(dropHoverTimer); openDrop(); });
      dropItem.addEventListener('mouseleave', function () { dropHoverTimer = window.setTimeout(function () { closeDrop(false); }, 220); });
    }
    dropItem.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && dropItem.classList.contains('is-open')) { e.preventDefault(); closeDrop(true); }
    });
    document.addEventListener('focusin', function (e) {
      if (dropItem.classList.contains('is-open') && !dropItem.contains(e.target)) { closeDrop(false); }
    });
    document.addEventListener('click', function (e) {
      if (dropItem.classList.contains('is-open') && !dropItem.contains(e.target)) { closeDrop(false); }
    });
  }

  /* Predictive search: the icon opens a centered spotlight overlay against
     /search/suggest.json; Enter still submits to the full results page. */
  var phOpenSearch = null;
  var searchPanel = header.querySelector('[data-ph-search]');
  var searchToggle = header.querySelector('[data-ph-search-toggle]');
  if (searchPanel && searchToggle && window.fetch) {
    var searchInput = searchPanel.querySelector('[data-ph-search-input]');
    var searchStatus = searchPanel.querySelector('[data-ph-search-status]');
    var searchResults = searchPanel.querySelector('[data-ph-search-results]');
    var searchAll = searchPanel.querySelector('[data-ph-search-all]');
    var searchAllLabel = searchPanel.querySelector('[data-ph-search-all-label]');
    var searchEmpty = searchPanel.querySelector('[data-ph-search-empty]');
    var searchScrim = header.querySelector('[data-ph-search-scrim]');
    var suggestUrl = searchPanel.getAttribute('data-suggest-url') || '/search/suggest.json';
    var searchAllBase = searchAll.getAttribute('href');
    var searchTimer = null;
    var searchSeq = 0;

    var openSearch = function () {
      if (searchScrim) searchScrim.classList.add('is-open');
      searchPanel.classList.add('is-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      if (window.lenis && window.lenis.stop) { window.lenis.stop(); }
      document.body.classList.add('ph-search-lock');
      window.setTimeout(function () { searchInput.focus(); }, 60);
    };
    phOpenSearch = openSearch;
    var closeSearch = function (returnFocus) {
      if (searchScrim) searchScrim.classList.remove('is-open');
      searchPanel.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ph-search-lock');
      if (window.lenis && window.lenis.start) { window.lenis.start(); }
      searchInput.value = '';
      clearResults();
      if (returnFocus) searchToggle.focus();
    };
    var clearResults = function () {
      searchResults.textContent = '';
      searchStatus.textContent = '';
      searchAll.hidden = true;
      if (searchEmpty) searchEmpty.hidden = false;
    };
    var fmtPrice = function (raw) {
      var n = parseFloat(String(raw).replace(/,/g, ''));
      if (isNaN(n)) return '';
      var opts = n % 1 === 0 ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      return '$' + n.toLocaleString('en-US', opts);
    };
    var thumbUrl = function (u) {
      return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=112';
    };
    var addItem = function (r, meta, img) {
      var a = document.createElement('a');
      a.className = 'ph-search__item';
      a.href = r.url;
      if (img) {
        var im = document.createElement('img');
        im.className = 'ph-search__thumb';
        im.src = thumbUrl(img.url);
        im.alt = img.alt || '';
        im.width = 56; im.height = 56; im.loading = 'lazy';
        a.appendChild(im);
      }
      var text = document.createElement('span');
      text.className = 'ph-search__item-text';
      var title = document.createElement('span');
      title.className = 'ph-search__item-title';
      title.textContent = r.title;
      text.appendChild(title);
      if (meta) {
        var m = document.createElement('span');
        m.className = 'ph-search__item-meta';
        m.textContent = meta;
        text.appendChild(m);
      }
      a.appendChild(text);
      searchResults.appendChild(a);
    };
    var addGroup = function (label) {
      var g = document.createElement('p');
      g.className = 'ph-search__group';
      g.textContent = label;
      searchResults.appendChild(g);
    };
    var renderResults = function (q, res) {
      clearResults();
      if (searchEmpty) searchEmpty.hidden = true;
      var products = (res.products || []);
      var pages = (res.pages || []);
      var articles = (res.articles || []);
      var total = products.length + pages.length + articles.length;
      if (!total) {
        searchStatus.textContent = 'No matches for "' + q + '". Try a different word, or see all results.';
      } else {
        searchStatus.textContent = '';
        products.forEach(function (p) {
          var meta = [p.vendor, fmtPrice(p.price)].filter(Boolean).join('  |  ');
          addItem(p, meta, p.featured_image);
        });
        if (pages.length) {
          addGroup('Guides and pages');
          pages.forEach(function (p) { addItem(p, null, null); });
        }
        if (articles.length) {
          addGroup('Articles');
          articles.forEach(function (p) { addItem(p, null, null); });
        }
      }
      searchAllLabel.textContent = 'See all results for "' + q + '"';
      // Carry the same type set + prefix matching the dropdown used, so the results page is a
      // faithful superset of these suggestions (not a stricter, possibly-empty query).
      searchAll.href = searchAllBase + '?q=' + encodeURIComponent(q) + '&type=product,page,article&options%5Bprefix%5D=last';
      searchAll.hidden = false;
    };
    var runSearch = function (q) {
      var seq = ++searchSeq;
      var url = suggestUrl + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last';
      window.fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (seq !== searchSeq || !data) return;
          renderResults(q, (data.resources && data.resources.results) || {});
        })
        .catch(function () { /* network hiccup: leave the panel as-is; Enter still reaches /search */ });
    };

    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (searchPanel.classList.contains('is-open')) {
        closeSearch(false);
      } else {
        openSearch();
      }
    });
    searchPanel.querySelector('[data-ph-search-close]').addEventListener('click', function () { closeSearch(true); });
    if (searchScrim) { searchScrim.addEventListener('click', function () { closeSearch(true); }); }
    searchPanel.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-ph-search-chip]') : null;
      if (!chip) { return; }
      var term = chip.getAttribute('data-ph-search-chip');
      searchInput.value = term;
      searchInput.focus();
      runSearch(term);
    });
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      window.clearTimeout(searchTimer);
      if (q.length < 2) { clearResults(); return; }
      searchTimer = window.setTimeout(function () { runSearch(q); }, 220);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        var first = searchResults.querySelector('a[href]');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    searchResults.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(searchResults.querySelectorAll('a[href]'));
      var idx = links.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown' && idx < links.length - 1) links[idx + 1].focus();
      else if (e.key === 'ArrowUp') { if (idx > 0) links[idx - 1].focus(); else searchInput.focus(); }
    });
    searchPanel.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && searchPanel.classList.contains('is-open')) {
        e.preventDefault();
        closeSearch(true);
      }
    });
    document.addEventListener('click', function (e) {
      if (searchPanel.classList.contains('is-open') && !searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        closeSearch(false);
      }
    });
    document.addEventListener('focusin', function (e) {
      if (searchPanel.classList.contains('is-open') && !searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        closeSearch(false);
      }
    });
  }

  /* Mobile drawer with focus management + scroll lock */
  var overlay = document.getElementById('ph-mobile-nav');
  var toggle = header.querySelector('[data-ph-nav-toggle]');
  var closeBtn = header.querySelector('[data-ph-nav-close]');
  var lastFocused = null;
  var inerted = [];

  var getFocusable = function () {
    if (!overlay) return [];
    return Array.prototype.slice.call(
      overlay.querySelectorAll('a[href], button:not([disabled])')
    ).filter(function (el) { return el.offsetParent !== null; });
  };

  var setSiblingsInert = function (on) {
    if (!overlay) return;
    if (on) {
      inerted = [];
      var nodes = document.body.children;
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node === overlay || node.contains(overlay)) continue;
        if (node.hasAttribute('aria-hidden')) continue;
        node.setAttribute('aria-hidden', 'true');
        inerted.push(node);
      }
    } else {
      inerted.forEach(function (node) { node.removeAttribute('aria-hidden'); });
      inerted = [];
    }
  };

  var openNav = function () {
    if (!overlay) return;
    lastFocused = document.activeElement;
    overlay.hidden = false;
    /* force reflow so the transform transition runs */
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    document.body.classList.add('ph-nav-open');
    setSiblingsInert(true);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
    } else {
      var focusables = getFocusable();
      if (focusables.length) focusables[0].focus();
    }
  };

  var closeNav = function () {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('ph-nav-open');
    setSiblingsInert(false);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var done = function () {
      overlay.hidden = true;
      overlay.removeEventListener('transitionend', done);
    };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      overlay.hidden = true;
    } else {
      overlay.addEventListener('transitionend', done);
      window.setTimeout(function () { if (!overlay.hidden) overlay.hidden = true; }, 400);
    }
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    } else if (toggle) {
      toggle.focus();
    }
  };

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (overlay && overlay.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  /* Mobile drawer Search: close the drawer and open the spotlight overlay.
     Falls back to the /search link if the JS search is unavailable. */
  var mobileSearch = overlay ? overlay.querySelector('[data-ph-mobile-search]') : null;
  if (mobileSearch) {
    mobileSearch.addEventListener('click', function (e) {
      if (!phOpenSearch) { return; }
      e.preventDefault();
      closeNav();
      var reduceM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(phOpenSearch, reduceM ? 0 : 200);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeNav();
      return;
    }
    if (e.key === 'Tab') {
      var focusables = getFocusable();
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      /* If focus somehow escaped the overlay, pull it back in */
      if (!overlay.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* Mobile Shop accordion */
  var accToggles = header.querySelectorAll('[data-ph-acc-toggle]');
  Array.prototype.forEach.call(accToggles, function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : btn.nextElementSibling;
      if (!panel) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cue = document.querySelector('[data-ph-scroll-cue]');
  if (!cue) return;

  var hero = document.getElementById('ph-hero');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Click: scroll to (and focus) the section after the hero, not the hero's
     own bottom edge. Falls back to the in-page #ph-hero-end anchor with no JS. */
  cue.addEventListener('click', function (e) {
    var next = hero && hero.nextElementSibling;
    if (!next) return;
    e.preventDefault();
    next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    /* Move keyboard focus so AT users land in the revealed section. */
    var hadTabindex = next.hasAttribute('tabindex');
    if (!hadTabindex) next.setAttribute('tabindex', '-1');
    try { next.focus({ preventScroll: true }); } catch (err) { next.focus(); }
    if (!hadTabindex) {
      next.addEventListener('blur', function onBlur() {
        next.removeAttribute('tabindex');
        next.removeEventListener('blur', onBlur);
      });
    }
  });

  /* Fade the cue once the page has scrolled past the fold. */
  if (reduce) return;

  var ticking = false;
  var update = function () {
    cue.setAttribute('data-hidden', window.scrollY > 120 ? 'true' : 'false');
    ticking = false;
  };
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-popup"]) return;
  try {
    
(function () {
  function ls(get, k, v) { try { return get ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(get, k, v) { try { return get ? sessionStorage.getItem(k) : sessionStorage.setItem(k, v); } catch (e) { return null; } }

  // Count this page view for the "second page in a session" trigger. This runs on
  // every storefront page (including excluded ones) so the count is accurate.
  var pv = (parseInt(ss(true, 'ph_pageviews'), 10) || 0) + 1;
  ss(false, 'ph_pageviews', String(pv));

  var root = document.querySelector('[data-ph-lp]');
  if (!root) return; // excluded page or disabled: counted, nothing to show.

  // Suppression: converted (persistent) or dismissed this session (session only).
  if (ls(true, 'ph_lead_captured') || ss(true, 'ph_lead_dismissed')) return;

  var dialog = root.querySelector('[data-ph-lp-dialog]');
  var form = root.querySelector('[data-ph-lp-form]');
  var emailInput = root.querySelector('[data-ph-lp-email]');
  var successEl = root.querySelector('[data-ph-lp-success]');
  var quizLink = root.querySelector('[data-ph-lp-quiz]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ENGAGED_MS = (parseInt(root.getAttribute('data-lp-delay'), 10) || 11) * 1000;
  var SECOND_PAGE_MS = 1500; // brief, so it is clearly after first paint, never on load
  var shown = false, engaged = 0, engagedTimer = null, secondTimer = null, retryTimer = null, lastFocus = null;

  function clearTimers() {
    if (engagedTimer) { clearInterval(engagedTimer); engagedTimer = null; }
    if (secondTimer) { clearTimeout(secondTimer); secondTimer = null; }
    if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
  }

  var releaseModal = null;

  function open() {
    if (shown) return;
    shown = true;
    clearTimers();
    lastFocus = document.activeElement;
    root.classList.add('is-shown');
    root.setAttribute('aria-hidden', 'false');
    // Force a reflow so the entry transition runs from the hidden state.
    void root.offsetWidth;
    root.classList.add('is-open');
    releaseModal = PHModal.open(root, dialog || root, function () { close('dismiss'); }, lastFocus);
    if (window.PHPrivacy) PHPrivacy.track('lead_popup_shown', { page_views: pv });
  }

  // Do not intrude while the cart drawer is open (checkout-adjacent). Poll briefly.
  function requestOpen() {
    if (shown) return;
    clearTimers();
    var otherModal = Array.from(document.querySelectorAll('[aria-modal="true"]')).some(function (el) { return !root.contains(el) && el.getClientRects().length && getComputedStyle(el).visibility === 'visible' && !el.closest('[hidden],[aria-hidden="true"]'); });
    if (PHModal.active() || PHModal.reserved() || otherModal) { retryTimer = setTimeout(requestOpen, 2000); return; }
    open();
  }

  function close(reason) {
    if (!shown) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    if (releaseModal) { releaseModal(); releaseModal = null; }
    if (reduce) { root.classList.remove('is-shown'); }
    else { setTimeout(function () { root.classList.remove('is-shown'); }, 260); }
    // A dismiss suppresses for this session only; a conversion is handled on submit.
    if (reason !== 'converted') ss(false, 'ph_lead_dismissed', '1');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  var closers = root.querySelectorAll('[data-ph-lp-close]');
  for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', function () { close('dismiss'); });

  // Choosing the quiz is a positive engagement: do not nag again this session.
  if (quizLink) quizLink.addEventListener('click', function () { ss(false, 'ph_lead_dismissed', '1'); });

  var pending = false;
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (pending || !form.reportValidity()) return;
    var email = emailInput.value.trim(), btn = form.querySelector('button[type="submit"]');
    var error = root.querySelector('[data-ph-lp-error]'), label = btn.textContent;
    pending = true; btn.disabled = true; emailInput.disabled = true; btn.textContent = 'Sending…';
    form.setAttribute('aria-busy', 'true'); error.hidden = true;
    Promise.resolve().then(function () { return PHLead.guide(email, 'Lead Capture Popup', { 'Lead Source': 'Lead Capture Popup', 'Guide Requested': true }); }).then(function (result) {
      successEl.textContent = result.guideRequested ? 'Your subscription and guide request were accepted. Email delivery is not confirmed; you can read the guide below.' : 'Your subscription was accepted, but we could not confirm the guide email request. Read the guide below or contact us.';
      successEl.hidden = false; btn.textContent = 'Accepted';
      if (window.PHPrivacy) PHPrivacy.track('lead_popup_guide', { page_views: pv });
    }).catch(function () {
      error.textContent = 'We could not confirm your request. Your email is still here. Try again or read the guide below.'; error.hidden = false;
      pending = false; btn.disabled = false; emailInput.disabled = false; btn.textContent = label;
    }).finally(function () { form.removeAttribute('aria-busy'); });
  });

  // Triggers: ~11s engaged (visible) time OR the second page viewed, whichever first.
  engagedTimer = setInterval(function () {
    if (document.visibilityState === 'visible') engaged += 1000;
    if (engaged >= ENGAGED_MS) requestOpen();
  }, 1000);
  if (pv >= 2) secondTimer = setTimeout(requestOpen, SECOND_PAGE_MS);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var band = document.querySelector('[data-ph-band]');
  if (!band) return;
  var bg = band.querySelector('[data-ph-band-bg]');
  if (!bg) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function update() {
    var rect = band.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom > 0 && rect.top < vh) {
      // progress: -1 (band below) to 1 (band above); 0 when centered
      var progress = (rect.top + rect.height / 2 - vh / 2) / (vh + rect.height / 2);
      bg.style.transform = 'translate3d(0,' + (progress * -7) + '%,0)';
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ph-cartpage]');
  if (!root || !window.fetch) return;
  var form = root.querySelector('.ph-cartpage__form');
  if (!form) return;

  var currency = root.getAttribute('data-currency') || 'USD';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
  function money(c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); }
  function routeBase() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/'; }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var G = window.gsap;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = !!G && !reduce;

  // Serialize every cart write so a note save and a quantity change never race.
  function enqueue(fn) { return fn(); }
  function post(url, body) {
    return window.PHCartRequest.request(url, body, 'page');
  }
  var errorEl = document.createElement('p'); errorEl.setAttribute('role', 'alert'); errorEl.hidden = true; root.prepend(errorEl);
  function fail(error) { errorEl.textContent = error.message || 'Unable to update the cart. Please refresh and try again.'; errorEl.hidden = false; }
  function stale() {
    root.setAttribute('data-ph-cart-stale', 'true');
    fail(new Error('Your cart changed in another view. Refresh this page before checking out. Copy any unsaved delivery note first.'));
    if (!root.querySelector('[data-ph-cart-reload]')) { var link = document.createElement('a'); link.href = location.href; link.textContent = 'Refresh cart'; link.setAttribute('data-ph-cart-reload', ''); errorEl.after(link); }
    window.PHCartRequest.syncControls();
  }

  var minusSvg = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" focusable="false" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var plusSvg = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" focusable="false" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  var srEl = document.createElement('p');
  srEl.className = 'ph-cartpage__sr'; srEl.setAttribute('role', 'status'); srEl.setAttribute('aria-live', 'polite');
  root.appendChild(srEl);
  function announce(msg) { srEl.textContent = ''; requestAnimationFrame(function () { srEl.textContent = msg; }); }
  function refreshAffirm() { try { if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh(); } catch (e) {} }

  function applyCart(cart) {
    form.querySelectorAll('[data-ph-line]').forEach(function (line) {
      var key = line.getAttribute('data-key'), it = null;
      for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { it = cart.items[i]; break; } }
      if (!it) return;
      line.setAttribute('data-qty', it.quantity);
      var count = line.querySelector('[data-ph-count]'); if (count) count.textContent = it.quantity;
      var input = line.querySelector('.ph-cartpage__qty-input'); if (input) input.value = it.quantity;
      var dec = line.querySelector('[data-ph-dec]'); if (dec) dec.disabled = it.quantity <= 1;
      var lt = line.querySelector('[data-ph-linetotal]'); if (lt) lt.textContent = money(it.final_line_price);
      var aff = line.querySelector('.ph-cartpage__affirm'); if (aff) aff.setAttribute('data-amount', it.final_line_price);
    });
    var sub = root.querySelector('[data-ph-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    var sumAff = root.querySelector('.ph-cartpage__summary-affirm'); if (sumAff) sumAff.setAttribute('data-amount', cart.total_price);
    document.querySelectorAll('[data-ph-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    refreshAffirm();
  }
  function matchingLines(cart) {
    var keys = form.hidden ? [] : Array.from(form.querySelectorAll('[data-ph-line]')).map(function (el) { return el.getAttribute('data-key'); }).sort();
    return JSON.stringify(keys) === JSON.stringify(cart.items.map(function (x) { return x.key; }).sort());
  }
  document.addEventListener('ph:cart:state', function (event) {
    if (event.detail.source === 'page') return;
    if (!matchingLines(event.detail.cart)) stale();
    else applyCart(event.detail.cart);
  });
  function recheck() { window.PHCartRequest.request('cart.js', undefined, 'page-check').catch(fail); }
  window.addEventListener('focus', recheck);
  window.addEventListener('pageshow', function (event) { if (event.persisted) recheck(); });

  function changeQty(line, qty) {
    if (window.PHCartRequest.busy() || root.hasAttribute('data-ph-cart-stale')) return;
    var key = line.getAttribute('data-key');
    line.setAttribute('data-busy', 'true');
    enqueue(function () {
      return post('cart/change.js', { id: key, quantity: qty })
        .then(function (cart) { applyCart(cart); var item = cart.items.find(function (it) { return it.key === key; }); if (item) announce('Quantity updated to ' + item.quantity + '. Subtotal ' + money(cart.total_price) + '.'); else stale(); })
        .catch(fail)
        .then(function () { line.removeAttribute('data-busy'); });
    });
  }

  // Build a live stepper per line; keep the number input in the DOM (hidden) so
  // the form still posts a correct updates[] value if the shopper hits Checkout.
  form.querySelectorAll('[data-ph-line]').forEach(function (line) {
    try {
      var wrap = line.querySelector('.ph-cartpage__qty');
      var input = line.querySelector('.ph-cartpage__qty-input');
      if (!wrap || !input) return;
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
      var step = document.createElement('div');
      step.className = 'ph-cartpage__stepper';
      step.innerHTML =
        '<button type="button" class="ph-cartpage__step" data-ph-dec aria-label="Decrease quantity"' + (qty <= 1 ? ' disabled' : '') + '>' + minusSvg + '</button>'
        + '<span class="ph-cartpage__stepcount" data-ph-count>' + qty + '</span>'
        + '<button type="button" class="ph-cartpage__step" data-ph-inc aria-label="Increase quantity">' + plusSvg + '</button>';
      wrap.appendChild(step);
      input.setAttribute('hidden', '');
      input.disabled = true; // AJAX already saved quantities; do not overwrite a fresher server cart at checkout.
      step.addEventListener('click', function (e) {
        var q = parseInt(line.getAttribute('data-qty'), 10) || 1;
        if (e.target.closest('[data-ph-dec]')) { if (q > 1) changeQty(line, q - 1); }
        else if (e.target.closest('[data-ph-inc]')) { changeQty(line, q + 1); }
      });
    } catch (err) {}
  });

  // Remove with undo.
  function collapse(el, done) {
    if (animate) { el.style.overflow = 'hidden'; G.to(el, { height: 0, paddingTop: 0, paddingBottom: 0, opacity: 0, duration: 0.28, ease: 'power2.inOut', onComplete: done }); }
    else { el.style.display = 'none'; done(); }
  }
  function undoAdd(item, button, removedCart) {
    if (button.disabled) return;
    button.disabled = true;
    return window.PHCartRequest.recover(item, button.getAttribute('data-recovery') === 'unknown', 'page', removedCart).then(function (result) {
      if (result.state === 'restored') {
        button.closest('.ph-cartpage__undo').remove();
        window.location.reload();
        return;
      }
      button.setAttribute('data-recovery', result.state);
      button.disabled = false;
      button.textContent = result.state === 'absent' ? 'Retry Undo' : 'Refresh cart';
      if (result.cart) {
        if (!matchingLines(result.cart)) stale();
        else {
          applyCart(result.cart);
          // A fresh matching read resolves only the stale state this recovery
          // created. A separately detected structural change still needs reload.
          if (result.state === 'absent' && root.getAttribute('data-ph-cart-stale') === 'recovery') root.removeAttribute('data-ph-cart-stale');
        }
      }
      if (result.state === 'unknown' && !root.hasAttribute('data-ph-cart-stale')) root.setAttribute('data-ph-cart-stale', 'recovery');
      window.PHCartRequest.syncControls();
      if (!root.querySelector('[data-ph-cart-reload]')) fail(result.error || new Error(result.state === 'absent' ? 'The item is still removed. You can retry Undo.' : 'We could not confirm the restored quantity. Refresh the cart before trying again.'));
    });
  }
  function showRowUndo(anchor, item, title, removedCart) {
    var bar = document.createElement('div');
    bar.className = 'ph-cartpage__undo';
    bar.innerHTML = '<span>Removed ' + escapeHtml(title) + '.</span> <button type="button" class="ph-cartpage__undo-btn">Undo</button>';
    anchor.parentNode.insertBefore(bar, anchor.nextSibling);
    var t = setTimeout(function () { bar.remove(); }, 6500);
    bar.querySelector('.ph-cartpage__undo-btn').addEventListener('click', function (e) { clearTimeout(t); undoAdd(item, e.currentTarget, removedCart); });
  }
  function showEmptyUndo(item, title, removedCart) {
    var bar = document.createElement('div');
    bar.className = 'ph-cartpage__undo ph-cartpage__undo--full';
    bar.innerHTML = '<span>Removed ' + escapeHtml(title) + '.</span> <button type="button" class="ph-cartpage__undo-btn">Undo</button>';
    form.parentNode.insertBefore(bar, form);
    form.hidden = true;
    var browse = document.createElement('a'); browse.href = routeBase() + 'collections/all-saunas'; browse.textContent = ' Continue shopping'; bar.appendChild(browse);
    bar.querySelector('.ph-cartpage__undo-btn').addEventListener('click', function (e) { undoAdd(item, e.currentTarget, removedCart); });
  }
  form.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-ph-remove]');
    if (!rm) return;
    e.preventDefault();
    var line = rm.closest('[data-ph-line]');
    if (!line || line.getAttribute('data-busy') === 'true') return;
    if (window.PHCartRequest.busy() || root.hasAttribute('data-ph-cart-stale')) return;
    var key = line.getAttribute('data-key');
    var item;
    try { item = JSON.parse(line.getAttribute('data-ph-line-item')); item.quantity = parseInt(line.getAttribute('data-qty'), 10); } catch (e) { fail(new Error('Please refresh the cart before removing this item.')); return; }
    var nameEl = line.querySelector('.ph-cartpage__name');
    var title = nameEl ? nameEl.textContent.trim() : 'Item';
    line.setAttribute('data-busy', 'true');
    enqueue(function () {
      return post('cart/change.js', { id: key, quantity: 0 }).then(function (cart) {
        announce('Removed ' + title + '.');
        if (cart.item_count === 0) {
          applyCart(cart); showEmptyUndo(item, title, cart);
        } else {
          showRowUndo(line, item, title, cart);
          collapse(line, function () { line.remove(); });
          applyCart(cart);
        }
      }).catch(function (error) { line.removeAttribute('data-busy'); fail(error); });
    });
  });

  // Auto-save the delivery-access note.
  var note = form.querySelector('[data-ph-note]');
  if (note) {
    var saved = document.createElement('span');
    saved.className = 'ph-cartpage__saved'; saved.setAttribute('aria-live', 'polite');
    note.parentNode.appendChild(saved);
    var noteT;
    function saveNote() {
      var value = note.value;
      enqueue(function () {
        saved.textContent = 'Saving…';
        return post('cart/update.js', { note: value }).then(function (cart) {
          if (note.value === value) saved.textContent = cart.note === value ? 'Saved' : 'Could not confirm note. Please check before checkout.';
        }).catch(function (error) { saved.textContent = 'Could not save note. It is still in this form.'; fail(error); });
      });
    }
    note.addEventListener('input', function () { clearTimeout(noteT); noteT = setTimeout(saveNote, 700); });
    note.addEventListener('blur', function () { clearTimeout(noteT); saveNote(); });
    form.addEventListener('submit', function () { clearTimeout(noteT); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ph-collection]');
  if (!root) return;
  var grid = root.querySelector('[data-ph-grid]');
  if (!grid) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-ph-item]'));
  // An out-of-range Shopify page contains no server-rendered products. Keep its
  // recovery link and URL intact instead of rewriting it to the populated base URL.
  if (!items.length) {
    root.classList.add('ph-col--empty-page');
    var shown = root.querySelector('[data-ph-shown]');
    if (shown) shown.textContent = '0';
    return;
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 12;
  var currentPage = 1;
  var pagerEl = root.querySelector('[data-ph-pager]');

  function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }

  // Count-up on the "X of Y" result count: the number ticks to its new value when
  // filters apply, so the change registers as motion. Cancels any in-flight tween
  // so quick successive filters stay smooth; reduced-motion snaps instantly.
  function animateCount(el, to) {
    to = Math.round(to);
    if (el._cntRAF) { cancelAnimationFrame(el._cntRAF); el._cntRAF = null; }
    if (reduce) { el.textContent = to; el._cntVal = to; return; }
    var from = (typeof el._cntVal === 'number') ? el._cntVal : (parseInt(el.textContent, 10) || 0);
    if (from === to) { el.textContent = to; el._cntVal = to; return; }
    var start = null, dur = 420;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(from + (to - from) * eased);
      if (p < 1) { el._cntRAF = requestAnimationFrame(step); }
      else { el._cntRAF = null; el._cntVal = to; }
    }
    el._cntVal = from;
    el._cntRAF = requestAnimationFrame(step);
  }

  function capBucket(raw) {
    var nums = (raw || '').match(/\d+/g);
    if (!nums) return null;
    var max = Math.max.apply(null, nums.map(Number));
    if (max <= 2) return '1-2 Person';
    if (max <= 4) return '3-4 Person';
    if (max <= 6) return '5-6 Person';
    return '7+ Person';
  }
  // EMF values are often compound ("Low EMF / Ultra-Low EMF", "Near-Zero EMF (Infrared mode)").
  // Split on "/", strip parentheticals, and keep only real EMF levels so each is independently
  // selectable (a shopper filtering "Ultra-Low EMF" finds every product that offers it).
  function normalizeEmf(part) {
    var s = part.replace(/\([^)]*\)/g, '').trim().toLowerCase();
    if (s.indexOf('ultra') !== -1) return 'Ultra-Low EMF';
    if (s.indexOf('near-zero') !== -1 || s.indexOf('near zero') !== -1) return 'Near-Zero EMF';
    if (s.indexOf('low emf') !== -1 || s === 'low') return 'Low EMF';
    return null;
  }
  // Returns the list of facet values for an item (multi-value for EMF, single-element otherwise).
  function itemVals(item, facet) {
    if (facet === 'type') {
      var types = []; try { types = JSON.parse(item.getAttribute('data-types') || '[]'); } catch (e) {}
      var result = PHGuidance.heatTypes(types, item.getAttribute('data-heater'));
      return result.length ? result : [item.getAttribute('data-type')].filter(Boolean);
    }
    if (facet === 'emf') {
      var out = [];
      (item.getAttribute('data-emf') || '').split('/').forEach(function (part) {
        var n = normalizeEmf(part); if (n && out.indexOf(n) === -1) out.push(n);
      });
      return out;
    }
    if (facet === 'capacity') { var c = capBucket(item.getAttribute('data-capacity')); return c ? [c] : []; }
    var v = item.getAttribute('data-' + facet);
    return v ? [v] : [];
  }

  /* ---------- Build facet options from the rendered products ---------- */
  var FACETS = ['type', 'capacity', 'brand', 'emf', 'placement'];
  FACETS.forEach(function (facet) {
    var group = root.querySelector('[data-ph-facet="' + facet + '"]');
    if (!group) return;
    var opts = group.querySelector('[data-ph-facet-opts]');
    var counts = {};
    items.forEach(function (it) { itemVals(it, facet).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
    var values = Object.keys(counts).sort(function (a, b) {
      if (facet === 'capacity' || facet === 'type') return a.localeCompare(b);
      return counts[b] - counts[a] || a.localeCompare(b);
    });
    if (!values.length) { group.hidden = true; return; }
    values.forEach(function (v) {
      var label = document.createElement('label');
      label.className = 'ph-facet__opt';
      var input = document.createElement('input');
      input.type = 'checkbox'; input.setAttribute('data-ph-check', facet); input.value = v;
      var title = document.createElement('span'); title.textContent = v;
      var count = document.createElement('span'); count.className = 'ph-facet__opt-count'; count.textContent = counts[v];
      label.append(input, title, count);
      opts.appendChild(label);
    });
  });

  /* ---------- State ---------- */
  var sortSel = root.querySelector('[data-ph-sort]');
  var shownEl = root.querySelector('[data-ph-shown]');
  var chipsEl = root.querySelector('[data-ph-chips]');
  var emptyEl = root.querySelector('[data-ph-empty]');
  var clearAll = root.querySelectorAll('[data-ph-clear-all], [data-ph-clear-all-2]');
  var activeCountEl = root.querySelector('[data-ph-active-count]');

  /* ---------- Price range slider ----------
     Two overlaid range inputs produce a single "minCents-maxCents" range that
     feeds the existing matches() price logic unchanged. Bounds are derived from
     the collection's real prices. */
  var priceMinIn = root.querySelector('[data-ph-price-min]');
  var priceMaxIn = root.querySelector('[data-ph-price-max]');
  var priceFill = root.querySelector('[data-ph-price-fill]');
  var priceMinLbl = root.querySelector('[data-ph-price-min-label]');
  var priceMaxLbl = root.querySelector('[data-ph-price-max-label]');
  var priceAbsMin = 0, priceAbsMax = 0, priceStep = 5000; // cents ($50)
  function priceActive() { return !!priceMinIn && (+priceMinIn.value > priceAbsMin || +priceMaxIn.value < priceAbsMax); }
  function updatePriceUI() {
    if (!priceMinIn) return;
    var lo = +priceMinIn.value, hi = +priceMaxIn.value, span = (priceAbsMax - priceAbsMin) || 1;
    if (priceFill) { priceFill.style.left = ((lo - priceAbsMin) / span * 100) + '%'; priceFill.style.right = ((priceAbsMax - hi) / span * 100) + '%'; }
    if (priceMinLbl) priceMinLbl.textContent = money(lo);
    if (priceMaxLbl) priceMaxLbl.textContent = money(hi) + (hi >= priceAbsMax ? '+' : '');
    priceMinIn.setAttribute('aria-valuetext', money(lo));
    priceMaxIn.setAttribute('aria-valuetext', money(hi) + (hi >= priceAbsMax ? root.getAttribute('data-above-label') : ''));
  }
  function resetPrice() { if (priceMinIn) { priceMinIn.value = priceAbsMin; priceMaxIn.value = priceAbsMax; updatePriceUI(); } }
  (function initPriceSlider() {
    var group = root.querySelector('[data-ph-facet="price"]');
    if (!priceMinIn || !priceMaxIn || !items.length) { if (group) group.hidden = true; return; }
    var prices = items.map(function (it) { return parseInt(it.getAttribute('data-price'), 10) || 0; }).filter(function (p) { return p > 0; });
    if (!prices.length) { if (group) group.hidden = true; return; }
    priceAbsMin = Math.floor(Math.min.apply(null, prices) / priceStep) * priceStep;
    priceAbsMax = Math.ceil(Math.max.apply(null, prices) / priceStep) * priceStep;
    if (priceAbsMax <= priceAbsMin) priceAbsMax = priceAbsMin + priceStep;
    [priceMinIn, priceMaxIn].forEach(function (inp) { inp.min = priceAbsMin; inp.max = priceAbsMax; inp.step = priceStep; });
    priceMinIn.value = priceAbsMin; priceMaxIn.value = priceAbsMax;
    priceMinIn.addEventListener('input', function () { if (+priceMinIn.value > +priceMaxIn.value) priceMinIn.value = priceMaxIn.value; updatePriceUI(); });
    priceMaxIn.addEventListener('input', function () { if (+priceMaxIn.value < +priceMinIn.value) priceMaxIn.value = priceMinIn.value; updatePriceUI(); });
    // Narrowing the range shortens the results, which shrinks the document and lets the
    // browser clamp the scroll to the footer. Anchor the slider's viewport position across
    // the reflow so the shopper stays put on the control they are dragging.
    function sliderApply(e) {
      var handle = (e && e.target) || priceMinIn;
      var anchorTop = handle.getBoundingClientRect().top;
      apply();
      requestAnimationFrame(function () {
        var docTop = handle.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo(0, Math.max(0, docTop - anchorTop));
      });
    }
    priceMinIn.addEventListener('change', sliderApply);
    priceMaxIn.addEventListener('change', sliderApply);
    updatePriceUI();
  })();

  function selectedByFacet() {
    var map = {};
    root.querySelectorAll('[data-ph-check]:checked').forEach(function (c) {
      var f = c.getAttribute('data-ph-check');
      (map[f] = map[f] || []).push(c.value);
    });
    if (priceActive()) map.price = [(+priceMinIn.value) + '-' + (+priceMaxIn.value)];
    if (root.querySelector('[data-ph-instock]') && root.querySelector('[data-ph-instock]').checked) map.instock = true;
    return map;
  }
  // `except` lets facet counts ignore that facet's own selections, so a facet
  // still shows its other options (OR within a facet, AND across facets).
  function matches(item, sel, except) {
    for (var f in sel) {
      if (f === except || f === 'price' || f === 'instock') continue;
      var vals = itemVals(item, f);
      var hit = sel[f].some(function (s) { return vals.indexOf(s) !== -1; });
      if (!hit) return false;
    }
    if (except !== 'price' && sel.price) {
      var pc = parseInt(item.getAttribute('data-price'), 10), ok = false;
      sel.price.forEach(function (rng) { var p = rng.split('-'); if (pc >= +p[0] && pc <= +p[1]) ok = true; });
      if (!ok) return false;
    }
    if (except !== 'instock' && sel.instock && item.getAttribute('data-available') !== 'true') return false;
    return true;
  }

  // Live facet counts: recompute each option's tally against the items that match
  // every OTHER active filter, and dim options that would return nothing.
  function updateCounts(sel) {
    FACETS.forEach(function (facet) {
      var counts = {};
      items.forEach(function (it) { if (matches(it, sel, facet)) itemVals(it, facet).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
      root.querySelectorAll('[data-ph-check="' + facet + '"]').forEach(function (chk) {
        var n = counts[chk.value] || 0;
        var label = chk.closest ? chk.closest('.ph-facet__opt') : null;
        var cnt = label ? label.querySelector('.ph-facet__opt-count') : null;
        if (cnt) cnt.textContent = n;
        chk.disabled = (n === 0 && !chk.checked);
        if (label) label.classList.toggle('ph-facet__opt--empty', n === 0 && !chk.checked);
      });
    });
  }

  function renderChips(sel) {
    var chips = [];
    for (var f in sel) {
      if (f === 'instock') { chips.push({ f: f, v: true, label: 'In stock' }); continue; }
      if (f === 'price') { sel.price.forEach(function (r) { chips.push({ f: 'price', v: r, label: priceLabel(r) }); }); continue; }
      sel[f].forEach(function (v) { chips.push({ f: f, v: v, label: v }); });
    }
    chipsEl.innerHTML = '';
    chips.forEach(function (c) {
      var el = document.createElement('span');
      el.className = 'ph-col__chip';
      el.innerHTML = '<span></span><button type="button" aria-label="Remove filter"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" focusable="false"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>';
      el.querySelector('span').textContent = c.label;
      el.querySelector('button').setAttribute('aria-label', (root.getAttribute('data-remove-label') || 'Remove __value__ filter').replace('__value__', c.label));
      el.querySelector('button').addEventListener('click', function () { removeFilter(c.f, c.v); });
      chipsEl.appendChild(el);
    });
    chipsEl.hidden = chips.length === 0;
    if (activeCountEl) { activeCountEl.textContent = chips.length; activeCountEl.hidden = chips.length === 0; }
    clearAll.forEach(function (b) { b.hidden = chips.length === 0; });
    return chips.length;
  }
  function priceLabel(r) {
    var p = (r || '').split('-');
    if (p.length !== 2) return 'Price';
    return money(+p[0]) + ' to ' + money(+p[1]) + (+p[1] >= priceAbsMax ? '+' : '');
  }
  function removeFilter(f, v) {
    if (f === 'instock') { var c = root.querySelector('[data-ph-instock]'); if (c) c.checked = false; }
    else if (f === 'price') { resetPrice(); }
    else { root.querySelectorAll('[data-ph-check="' + f + '"]').forEach(function (c) { if (c.value === v) c.checked = false; }); }
    apply();
  }

  function sortItems() {
    var mode = sortSel ? sortSel.value : 'featured';
    var sorted = items.slice().sort(function (a, b) {
      if (mode === 'price-asc') return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
      if (mode === 'price-desc') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
      if (mode === 'title-asc') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
      return (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
    });
    sorted.forEach(function (it) { grid.appendChild(it); });
    return sorted;
  }

  function apply(keepPage) {
    keepPage = keepPage === true;
    var sel = selectedByFacet();
    var sorted = sortItems();
    var matched = [];
    sorted.forEach(function (item) {
      var ok = matches(item, sel);
      item.classList.toggle('is-hidden', !ok);
      if (ok) matched.push(item);
    });
    if (!keepPage) currentPage = 1;
    paginate(matched);
    if (shownEl) animateCount(shownEl, matched.length);
    renderChips(sel);
    updateCounts(sel);
    if (emptyEl) emptyEl.setAttribute('data-visible', matched.length === 0 ? 'true' : 'false');
    syncURL(sel);
  }

  /* ---------- Client-side pagination ----------
     The whole collection stays in the DOM so filtering tests every product; the
     pager only limits how many of the CURRENTLY MATCHED items are shown per page.
     Filter/sort changes reset to page 1; page clicks keep the active filters. */
  function paginate(matched) {
    var total = matched.length;
    var pages = Math.max(1, Math.ceil(total / pageSize));
    if (currentPage > pages) currentPage = pages;
    if (currentPage < 1) currentPage = 1;
    var start = (currentPage - 1) * pageSize, end = start + pageSize;
    matched.forEach(function (item, i) {
      var onPage = i >= start && i < end;
      item.classList.toggle('is-page-hidden', !onPage);
      if (onPage) {
        if (item.classList.contains('ph-reveal')) item.classList.add('is-visible');
        var rev = item.querySelectorAll('.ph-reveal');
        for (var k = 0; k < rev.length; k++) rev[k].classList.add('is-visible');
      }
    });
    renderPager(pages, total, start, end);
  }

  // Windowed page numbers: always first + last, current +/- 1, ellipsis for gaps.
  function pageWindow(cur, pages) {
    var out = [], i;
    if (pages <= 7) { for (i = 1; i <= pages; i++) out.push(i); return out; }
    out.push(1);
    var lo = Math.max(2, cur - 1), hi = Math.min(pages - 1, cur + 1);
    if (lo > 2) out.push('gap');
    for (i = lo; i <= hi; i++) out.push(i);
    if (hi < pages - 1) out.push('gap');
    out.push(pages);
    return out;
  }

  function renderPager(pages, total, start, end) {
    if (!pagerEl) return;
    if (pages <= 1) { pagerEl.innerHTML = ''; pagerEl.hidden = true; return; }
    pagerEl.hidden = false;
    var chevPrev = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var chevNext = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var html = '<button type="button" class="ph-col__pg ph-col__pg--edge" data-pg="prev"' + (currentPage <= 1 ? ' disabled' : '') + ' aria-label="Previous page">' + chevPrev + '<span>Prev</span></button>';
    pageWindow(currentPage, pages).forEach(function (n) {
      if (n === 'gap') { html += '<span class="ph-col__pg-gap" aria-hidden="true">...</span>'; return; }
      html += '<button type="button" class="ph-col__pg" data-pg="' + n + '"' + (n === currentPage ? ' aria-current="page"' : '') + ' aria-label="Page ' + n + '">' + n + '</button>';
    });
    html += '<button type="button" class="ph-col__pg ph-col__pg--edge" data-pg="next"' + (currentPage >= pages ? ' disabled' : '') + ' aria-label="Next page"><span>Next</span>' + chevNext + '</button>';
    html += '<p class="ph-col__pager-info">Page ' + currentPage + ' of ' + pages + ', showing ' + (start + 1) + ' to ' + Math.min(end, total) + ' of ' + total + '</p>';
    pagerEl.innerHTML = html;
  }

  // Jump back to the top of the results when the page changes, so the shopper starts
  // the new page at its first sauna instead of staying at the pager. Deferred one frame
  // so the measurement reflects the re-paginated layout; offset clears the sticky header.
  function scrollToTop() {
    var target = root.querySelector('.ph-col__toolbar') || grid || root;
    requestAnimationFrame(function () {
      var y = window.pageYOffset + target.getBoundingClientRect().top - 100;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- URL sync (shareable filtered views) ---------- */
  function syncURL(sel) {
    var params = new URLSearchParams();
    ['type', 'capacity', 'brand', 'emf', 'placement'].forEach(function (f) { if (sel[f]) params.set(f, sel[f].join('|')); });
    if (sel.price) params.set('price', sel.price.join('|'));
    if (sel.instock) params.set('instock', '1');
    if (sortSel && sortSel.value !== 'featured') params.set('sort', sortSel.value);
    if (currentPage > 1) params.set('page', currentPage);
    var qs = params.toString();
    try { window.history.replaceState({}, '', qs ? '?' + qs : window.location.pathname); } catch (e) {}
  }
  function readURL() {
    var params = new URLSearchParams(window.location.search);
    ['type', 'capacity', 'brand', 'emf', 'placement'].forEach(function (f) {
      var val = params.get(f); if (!val) return;
      val.split('|').forEach(function (v) { root.querySelectorAll('[data-ph-check="' + f + '"]').forEach(function (c) { if (c.value === v) c.checked = true; }); });
    });
    if (params.get('price') && priceMinIn) { var pr = params.get('price').split('|')[0].split('-'); if (pr.length === 2) { priceMinIn.value = Math.max(priceAbsMin, Math.min(priceAbsMax, +pr[0])); priceMaxIn.value = Math.max(priceAbsMin, Math.min(priceAbsMax, +pr[1])); if (+priceMinIn.value > +priceMaxIn.value) priceMinIn.value = priceMaxIn.value; updatePriceUI(); } }
    if (params.get('instock')) { var ic = root.querySelector('[data-ph-instock]'); if (ic) ic.checked = true; }
    if (params.get('sort') && sortSel) sortSel.value = params.get('sort');
    var pg = params.get('page'); if (pg) currentPage = Math.max(1, parseInt(pg, 10) || 1);
  }

  /* ---------- Wire events ---------- */
  root.querySelectorAll('[data-ph-check], [data-ph-instock]').forEach(function (c) { c.addEventListener('change', apply); });
  if (sortSel) sortSel.addEventListener('change', apply);
  if (pagerEl) {
    pagerEl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pg]') : null;
      if (!b || b.disabled) return;
      var v = b.getAttribute('data-pg');
      if (v === 'prev') currentPage = Math.max(1, currentPage - 1);
      else if (v === 'next') currentPage = currentPage + 1;
      else currentPage = parseInt(v, 10) || 1;
      apply(true);
      scrollToTop();
    });
  }
  clearAll.forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-ph-check]:checked, [data-ph-instock]:checked').forEach(function (c) { c.checked = false; });
      resetPrice();
      closeRail();
      apply();
    });
  });

  /* ---------- Mobile drawer ---------- */
  var rail = root.querySelector('[data-ph-rail]');
  var scrim = root.querySelector('[data-ph-scrim]');
  var releaseRail = null, railMedia = window.matchMedia('(max-width: 900px)');
  function openRail() {
    if (!rail || !railMedia.matches || releaseRail) return;
    rail.inert = false; rail.removeAttribute('aria-hidden'); rail.setAttribute('role', 'dialog'); rail.setAttribute('aria-modal', 'true'); rail.setAttribute('data-open', 'true');
    openBtn.setAttribute('aria-expanded', 'true');
    if (scrim) { scrim.hidden = false; scrim.setAttribute('data-open', 'true'); }
    document.documentElement.style.overflow = 'hidden';
    releaseRail = PHModal.open(rail, rail, closeRail, openBtn, [scrim]);
  }
  function closeRail() {
    if (!rail) return;
    if (releaseRail) { releaseRail(); releaseRail = null; document.documentElement.style.overflow = ''; }
    rail.removeAttribute('data-open'); rail.removeAttribute('aria-modal'); rail.removeAttribute('role');
    rail.inert = railMedia.matches;
    if (railMedia.matches) rail.setAttribute('aria-hidden', 'true'); else rail.removeAttribute('aria-hidden');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (scrim) { scrim.removeAttribute('data-open'); scrim.hidden = true; }
  }
  var openBtn = root.querySelector('[data-ph-rail-open]');
  var closeBtn = root.querySelector('[data-ph-rail-close]');
  if (openBtn) openBtn.addEventListener('click', openRail);
  if (closeBtn) closeBtn.addEventListener('click', closeRail);
  if (scrim) scrim.addEventListener('click', closeRail);
  railMedia.addEventListener('change', closeRail);
  closeRail();

  readURL();
  apply(true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ph-pdp]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var hasGSAP = !reduce && window.gsap && window.ScrollTrigger;
  if (hasGSAP) { try { window.gsap.registerPlugin(window.ScrollTrigger); } catch (e) { hasGSAP = false; } }

  /* ---------- Zoom lightbox (built once) ---------- */
  var lightbox = null, lbImg = null, lbZoomed = false, releaseImageModal = null, imageOverflow = null;
  function buildLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'ph-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image');
    lightbox.innerHTML = '<button type="button" class="ph-lightbox__close ph-x" aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" focusable="false"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button><img class="ph-lightbox__img" alt="">';
    document.body.appendChild(lightbox);
    lbImg = lightbox.querySelector('.ph-lightbox__img');
    lightbox.querySelector('.ph-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    lbImg.addEventListener('click', function (e) { e.stopPropagation(); toggleLbZoom(e); });
    lbImg.addEventListener('mousemove', function (e) { if (lbZoomed) panLb(e); });
  }
  function panLb(e) { var r = lbImg.getBoundingClientRect(); lbImg.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%'; lbImg.style.transform = 'scale(2.2)'; }
  function toggleLbZoom(e) { lbZoomed = !lbZoomed; lightbox.classList.toggle('is-zoomed', lbZoomed); if (lbZoomed) { panLb(e); } else { lbImg.style.transform = 'scale(1)'; lbImg.style.transformOrigin = 'center center'; } }
  function openCustomLightbox(src, alt, opener, request) {
    if (!src) return;
    buildLightbox();
    lbImg.src = src; lbImg.alt = alt || '';
    lbZoomed = false; lightbox.classList.remove('is-zoomed'); lbImg.style.transform = 'scale(1)';
    lightbox.classList.add('is-open');
    request.dialog = lightbox;
    releaseImageModal = PHModal.open(lightbox, lightbox, closeLightbox, opener);
    imageOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
  }
  // PhotoSwipe gives real pinch, pan and double-tap zoom on touch (the custom
  // lightbox above is mouse-only). Loaded on first zoom, never at page load, so
  // it costs nothing until used; if the CDN import fails we fall back to the
  // custom lightbox. A native module asset avoids Shopify's import rewriting.
  var galleryRequest = null, activePswp = null, galleryDestroyed = false;
  function anotherImageDialog() {
    return PHModal.active() || Array.from(document.querySelectorAll('[aria-modal="true"]')).some(function (el) {
      return el !== lightbox && el.getClientRects().length && getComputedStyle(el).visibility === 'visible' && !el.closest('[hidden],[aria-hidden="true"]');
    });
  }
  function stopWaitingForGallery(request) {
    request.pending = false;
    if (request.observer) { request.observer.disconnect(); request.observer = null; }
    if (request.escape) { document.removeEventListener('keydown', request.escape); request.escape = null; }
  }
  function finishGalleryRequest(request) {
    if (!request) return;
    stopWaitingForGallery(request);
    request.cancelled = true;
    request.release();
    if (galleryRequest === request) galleryRequest = null;
  }
  function mayOpenGallery(request) {
    return !request.cancelled && !galleryDestroyed && root.isConnected && !anotherImageDialog();
  }
  function destroyGalleryViewer(request) {
    var viewer = request && request.viewer;
    if (!viewer) return;
    request.viewer = null;
    // PhotoSwipe 5.4.4 destroy() otherwise delegates to close(), which ignores
    // calls during opening. Enter its immediate teardown path on unload/error.
    if (viewer.animations) viewer.animations.stopAll();
    viewer.isDestroying = true;
    try { viewer.destroy(); } catch (e) { /* still release our ownership */ }
    if (viewer.element) viewer.element.remove();
    if (request.releaseNative) { request.releaseNative(); request.releaseNative = null; }
    if (activePswp === viewer) activePswp = null;
  }
  function loadGalleryModule() {
    if (window.PHProductGallery) return Promise.resolve(window.PHProductGallery);
    if (window.__phProductGalleryPromise) return window.__phProductGalleryPromise;
    window.__phProductGalleryPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'module';
      var url = root.getAttribute('data-ph-gallery-module');
      var attempt = window.__phProductGalleryAttempt || 0;
      window.__phProductGalleryAttempt = attempt + 1;
      script.src = url + (attempt ? (url.indexOf('?') >= 0 ? '&' : '?') + 'ph_gallery_retry=' + attempt : '');
      var timer = setTimeout(function () { finish(new Error('Gallery module timed out.')); }, 12000);
      var settled = false;
      function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        script.onload = script.onerror = null;
        script.remove();
        if (error) reject(error);
        else resolve(window.PHProductGallery);
      }
      script.onload = function () {
        Promise.resolve(window.PHProductGalleryLoading || window.PHProductGallery).then(function (mod) {
          finish(mod && typeof mod.PhotoSwipe === 'function' ? null : new Error('Gallery module did not register.'));
        }, finish);
      };
      script.onerror = function () { finish(new Error('Gallery module could not load.')); };
      document.head.appendChild(script);
    }).catch(function (error) { window.__phProductGalleryPromise = null; throw error; });
    return window.__phProductGalleryPromise;
  }
  function ensurePswpCss() {
    if (document.getElementById('ph-pswp-css')) return;
    var l = document.createElement('link');
    l.id = 'ph-pswp-css'; l.rel = 'stylesheet';
    l.href = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.css';
    document.head.appendChild(l);
  }
  function pswpSlides() {
    return Array.prototype.map.call(root.querySelectorAll('.ph-gallery__panel img[data-zoom-src]'), function (img) {
      var w = img.naturalWidth || 1800, h = img.naturalHeight || 1800, k = 1800 / w;
      return { src: img.getAttribute('data-zoom-src'), width: Math.round(w * k), height: Math.round(h * k), alt: img.alt };
    });
  }
  function openLightbox(src, alt) {
    if (!src || galleryRequest || activePswp || (lightbox && lightbox.classList.contains('is-open')) || galleryDestroyed || anotherImageDialog()) return;
    var opener = document.activeElement;
    var request = { pending:true, cancelled:false, observer:null };
    request.release = PHModal.reserve(function (nextDialog) {
      if (nextDialog === request.dialog) return;
      // Delayed cart completion may open after the gallery is already visible.
      // Retire that viewer before the next owner is isolated, including its
      // document keyboard listeners, while preserving the new owner's lock.
      destroyGalleryViewer(request);
      if (lightbox && lightbox.classList.contains('is-open')) closeLightbox(true);
      finishGalleryRequest(request);
      return opener;
    });
    galleryRequest = request;
    request.escape = function (event) {
      if (event.key === 'Escape' && request.pending) { event.preventDefault(); finishGalleryRequest(request); }
    };
    document.addEventListener('keydown', request.escape);
    // Header and ROI dialogs do not use PHModal. Remember their interruption
    // even if they close before the import settles, so old intent cannot reopen.
    request.observer = new MutationObserver(function () {
      if (request.pending && anotherImageDialog()) finishGalleryRequest(request);
    });
    request.observer.observe(document.body, {attributes:true, childList:true, subtree:true, attributeFilter:['hidden','aria-hidden','aria-modal','class','style']});
    ensurePswpCss();
    loadGalleryModule().then(function (m) {
      if (!mayOpenGallery(request)) { finishGalleryRequest(request); return; }
      stopWaitingForGallery(request);
      var slides = pswpSlides();
      if (!slides.length) throw new Error('no slides');
      var idx = 0;
      for (var i = 0; i < slides.length; i++) { if (slides[i].src === src) { idx = i; break; } }
      var viewer = new m.PhotoSwipe({ dataSource: slides, index: idx, bgOpacity: 0.92, showHideAnimationType: 'fade', wheelToZoom: true, trapFocus:false, returnFocus:false, escKey:false });
      request.viewer = viewer;
      activePswp = viewer;
      // PHModal owns focus and Escape; PhotoSwipe keeps arrows and zoom keys.
      viewer.on('keydown', function (event) {
        if (event.originalEvent.key === 'Tab' || !viewer.element || viewer.element.closest('[inert]')) event.preventDefault();
      });
      viewer.on('destroy', function () {
        if (activePswp === viewer) activePswp = null;
        if (request.releaseNative) { request.releaseNative(); request.releaseNative = null; }
        if (!request.handoff) finishGalleryRequest(request);
      });
      if (viewer.init() === false) throw new Error('Gallery could not open.');
      if (viewer.element) {
        viewer.element.setAttribute('aria-modal', 'true');
        request.dialog = viewer.element;
        request.releaseNative = PHModal.open(viewer.element, viewer.element, function () { viewer.close(); }, opener);
      }
    }).catch(function () {
      request.handoff = true;
      destroyGalleryViewer(request);
      if (mayOpenGallery(request)) { stopWaitingForGallery(request); openCustomLightbox(src, alt, opener, request); }
      else finishGalleryRequest(request);
    });
  }
  function unloadGallery(event) {
    if (!event.target.contains(root)) return;
    galleryDestroyed = true;
    destroyGalleryViewer(galleryRequest);
    finishGalleryRequest(galleryRequest);
    if (lightbox) { closeLightbox(); lightbox.remove(); lightbox = null; }
    document.removeEventListener('shopify:section:unload', unloadGallery);
  }
  document.addEventListener('shopify:section:unload', unloadGallery);
  function closeLightbox(preserveScroll) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    lightbox.classList.remove('is-open');
    if (releaseImageModal) { releaseImageModal(); releaseImageModal = null; }
    if (preserveScroll !== true && !PHModal.active() && document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = imageOverflow;
    imageOverflow = null;
    finishGalleryRequest(galleryRequest);
  }
  function zoomFor(id) { var p = root.querySelector('.ph-gallery__panel[data-media-id="' + id + '"] img'); return p ? { src: p.getAttribute('data-zoom-src') || p.src, alt: p.alt } : null; }

  /* ---------- Gallery ---------- */
  var galleryActivate = null; /* set inside the gallery block; used by updateVariant to swap the stage on variant change */
  var galleryFirstMedia = null; /* default (first) media id; fallback when a variant has no featured image of its own */
  var gallery = root.querySelector('[data-ph-gallery]');
  if (gallery) {
    var isSecondary = gallery.classList.contains('ph-gallery--secondary');
    var panels = gallery.querySelectorAll('[data-ph-panel]');
    var thumbs = gallery.querySelectorAll('[data-ph-thumb]');
    var activate = function (id) {
      panels.forEach(function (p) { var on = p.getAttribute('data-media-id') === id; p.classList.toggle('is-active', on); if (on) { p.removeAttribute('aria-hidden'); } else { p.setAttribute('aria-hidden', 'true'); } });
      thumbs.forEach(function (t) { var on = t.getAttribute('data-media-id') === id; t.classList.toggle('is-active', on); if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
    };
    /* Expose to variant switching so selecting a variant (e.g. flat vs peaked roof)
       jumps the gallery to that variant's featured image. Only for the primary
       gallery; secondary thumbs open the lightbox instead of switching the stage. */
    if (!isSecondary) { galleryActivate = activate; if (panels.length) { galleryFirstMedia = panels[0].getAttribute('data-media-id'); } }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        if (isSecondary) { var z = zoomFor(id); if (z) openLightbox(z.src, z.alt); }
        else { activate(id); }
      });
    });

    var stage = gallery.querySelector('[data-ph-zoomable]');
    var zoomBtn = gallery.querySelector('[data-ph-zoom-open]');
    var activeImg = function () { return gallery.querySelector('.ph-gallery__panel.is-active img'); };
    var openActive = function () { var img = activeImg(); if (img) openLightbox(img.getAttribute('data-zoom-src') || img.src, img.alt); };
    if (stage && !isSecondary) {
      var fineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (fineHover && !reduce) {
        stage.addEventListener('mousemove', function (e) {
          var img = activeImg(); if (!img) return;
          var r = stage.getBoundingClientRect();
          img.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
          img.style.transform = 'scale(2)';
          stage.classList.add('is-zooming');
        });
        stage.addEventListener('mouseleave', function () { var img = activeImg(); if (img) { img.style.transform = ''; img.style.transformOrigin = 'center center'; } stage.classList.remove('is-zooming'); });
      }
      stage.addEventListener('click', function (e) { if (e.target.closest('[data-ph-zoom-open]')) return; openActive(); });
    }
    if (zoomBtn) zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openActive(); });
  }

  /* ---------- 3D model: unveiling sequence (slow 360, settles at rest) ---------- */
  root.querySelectorAll('[data-ph-model]').forEach(function (wrap) {
    var mv = wrap.querySelector('model-viewer');
    var hint = wrap.querySelector('[data-ph-drag-hint]');
    var cursor = wrap.querySelector('[data-ph-model-cursor]');
    if (!mv) return;
    mv.setAttribute('camera-controls', '');
    mv.setAttribute('interaction-prompt', 'none');
    mv.setAttribute('touch-action', 'pan-y');
    var REST = -25, PHI = 78, RAD = '105%', tween = null, settled = false;
    var orbit = function (theta) { mv.cameraOrbit = theta + 'deg ' + PHI + 'deg ' + RAD; if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); };
    var settle = function () { if (settled) return; settled = true; if (tween) { tween.kill(); tween = null; } if (hint) hint.setAttribute('data-hidden', 'true'); };
    var unveil = function () {
      if (reduce || !window.gsap) { orbit(REST); if (hint) hint.setAttribute('data-hidden', 'true'); return; }
      var proxy = { t: REST - 360 };
      orbit(proxy.t);
      tween = window.gsap.to(proxy, { t: REST, duration: 3.4, ease: 'power2.inOut', onUpdate: function () { if (!settled) orbit(proxy.t); }, onComplete: function () { settled = true; } });
    };
    mv.addEventListener('pointerdown', settle);

    /* Rotate-cursor hint: trails the pointer on hover so drag-to-rotate is
       discoverable, retiring the moment the model is grabbed. Mouse/fine pointer
       and motion-on only; touch and reduced-motion keep the static Drag pill. */
    if (cursor && !reduce && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var cursorDone = false;
      wrap.addEventListener('pointermove', function (e) {
        if (cursorDone || (e.pointerType && e.pointerType !== 'mouse')) return;
        var r = wrap.getBoundingClientRect();
        cursor.style.transform = 'translate(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px)';
        cursor.classList.add('is-visible');
      });
      wrap.addEventListener('pointerleave', function () { cursor.classList.remove('is-visible'); });
      mv.addEventListener('pointerdown', function () { cursorDone = true; cursor.classList.remove('is-visible'); });
    }

    if (mv.loaded) { unveil(); } else { mv.addEventListener('load', unveil, { once: true }); }
  });

  /* ---------- Variants ---------- */
  var dataEl = root.querySelector('[data-ph-variant-data]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  var form = root.querySelector('[data-ph-form]') || root.querySelector('#ph-product-form');
  var idInput = root.querySelector('[data-ph-variant-id]');
  var amountEl = root.querySelector('[data-ph-amount]');
  var msrpEl = root.querySelector('[data-ph-msrp]');
  var affirmEl = root.querySelector('.affirm-as-low-as');
  var stockEl = root.querySelector('[data-ph-stock]');
  var stockText = root.querySelector('[data-ph-stock-text]');
  var addBtn = root.querySelector('[data-ph-add]');
  var addLabel = root.querySelector('[data-ph-add-label]');
  var stickyPrice = root.querySelector('[data-ph-sticky-price]');
  var stickyAdd = root.querySelector('[data-ph-sticky-add]');
  var stickyLabel = root.querySelector('[data-ph-sticky-label]');

  function selectedOptions() {
    var groups = root.querySelectorAll('[data-ph-option-index]');
    if (!groups.length) { return variants.length ? variants[0].options : []; }
    var out = [];
    groups.forEach(function (g) { var c = g.querySelector('[data-ph-option-value]:checked'); out.push(c ? c.value : null); });
    return out;
  }
  function matchVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function setStock(v) {
    if (!stockEl) return;
    stockEl.classList.remove('is-in', 'is-low', 'is-out');
    if (!v || !v.available) { stockEl.classList.add('is-out'); if (stockText) stockText.textContent = 'Currently unavailable'; return; }
    if (v.tracked && v.qty > 0 && v.qty <= 3) { stockEl.classList.add('is-low'); if (stockText) stockText.textContent = 'Limited availability'; }
    else { stockEl.classList.add('is-in'); if (stockText) stockText.textContent = 'In stock, ready to ship'; }
  }
  function refreshAffirm(cents) {
    if (!affirmEl) return;
    affirmEl.setAttribute('data-amount', String(cents));
    try { if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') window.affirm.ui.refresh(); } catch (e) {}
  }
  function updateVariant() {
    var v = matchVariant(selectedOptions());
    var bis = root.querySelector('[data-ph-bis]');
    if (bis) {
      bis.hidden = !v || v.available;
      if (v && bis.getAttribute('data-variant') !== String(v.id)) {
        bis.setAttribute('data-variant', v.id);
        var bisForm = bis.querySelector('form'), bisMsg = bis.querySelector('[data-ph-bis-msg]');
        if (bisForm) { bisForm.style.display = ''; bisForm.querySelector('button').disabled = false; }
        if (bisMsg) bisMsg.hidden = true;
      }
    }
    var wallet = root.querySelector('.ph-buybox__wallet'); if (wallet) wallet.hidden = !v || !v.available;
    if (!v) {
      if (idInput) { idInput.value = ''; idInput.disabled = true; }
      [addBtn, stickyAdd].forEach(function (b) { if (b) b.disabled = true; });
      [addLabel, stickyLabel].forEach(function (label) { if (label) label.textContent = 'Unavailable'; });
      setStock(null); return;
    }
    if (idInput) idInput.disabled = false;
    if (idInput) idInput.value = v.id;
    if (amountEl) amountEl.textContent = v.price;
    if (msrpEl) { if (v.compare) { msrpEl.textContent = v.compare; msrpEl.hidden = false; } else { msrpEl.hidden = true; } }
    if (stickyPrice) stickyPrice.textContent = v.price;
    setStock(v);
    refreshAffirm(v.cents);
    // keep the Will It Fit link on this variant's exact dimensions (roof variants differ)
    var fitLink = root.querySelector('[data-ph-fit-link]');
    if (fitLink) { try { var fu = new URL(fitLink.getAttribute('href'), location.origin); ['pw','pd','ph'].forEach(function(key){fu.searchParams.delete(key);}); fu.searchParams.set('variant', v.id); fitLink.setAttribute('href', fu.pathname + fu.search); } catch (e) {} }
    // jump the gallery to this variant's featured image (e.g. flat vs peaked roof shot);
    // variants without an image of their own fall back to the default (first) media so
    // the stage never stays stuck on a previously selected variant's photo
    if (galleryActivate) { var targetImg = (v.img != null) ? String(v.img) : galleryFirstMedia; if (targetImg) { galleryActivate(targetImg); } }
    var buyable = v.available && !adding;
    [addBtn, stickyAdd].forEach(function (b) { if (!b) return; if (buyable) { b.removeAttribute('disabled'); } else { b.setAttribute('disabled', ''); } });
    if (addLabel) addLabel.textContent = buyable ? 'Add to cart' : 'Sold out';
    if (stickyLabel) stickyLabel.textContent = buyable ? 'Add to cart' : 'Sold out';
    try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); } catch (e) {}
  }
  root.querySelectorAll('[data-ph-option-value]').forEach(function (r) { r.addEventListener('change', updateVariant); });

  /* ---------- Quantity ---------- */
  var qtyInput = root.querySelector('[data-ph-qty-input]');
  function clampQty() { var n = parseInt(qtyInput.value, 10); if (isNaN(n) || n < 1) n = 1; qtyInput.value = n; return n; }
  var down = root.querySelector('[data-ph-qty-down]');
  var up = root.querySelector('[data-ph-qty-up]');
  if (down) down.addEventListener('click', function () { qtyInput.value = Math.max(1, clampQty() - 1); });
  if (up) up.addEventListener('click', function () { qtyInput.value = clampQty() + 1; });
  if (qtyInput) qtyInput.addEventListener('change', clampQty);

  /* ---------- Add to cart: AJAX add, fly-to-cart, then open the drawer ---------- */
  /* All cart mutations route through window.PHCart (the drawer owns cart state and
     its own /cart.js refresh); this section never fetches the cart itself. */
  var cartIcon = document.querySelector('.ph-header__cart');
  function flyToCart() {
    if (reduce || !cartIcon) return;
    var stage = root.querySelector('.ph-gallery__panel.is-active img') || root.querySelector('.ph-gallery__img');
    if (!stage) return;
    var from = stage.getBoundingClientRect(), to = cartIcon.getBoundingClientRect();
    var clone = stage.cloneNode(true);
    clone.style.cssText = 'position:fixed;z-index:1000;left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;object-fit:contain;pointer-events:none;transition:all 0.7s cubic-bezier(0.25,0.46,0.45,0.94);border-radius:8px;';
    document.body.appendChild(clone);
    requestAnimationFrame(function () { clone.style.left = (to.left + to.width / 2 - 20) + 'px'; clone.style.top = (to.top + to.height / 2 - 20) + 'px'; clone.style.width = '40px'; clone.style.height = '40px'; clone.style.opacity = '0.2'; });
    setTimeout(function () { clone.remove(); }, 720);
  }
  /* Success state: the label slides out and a check + Added slides in, holds,
     then settles back. Reduced-motion / no-GSAP toggles the data-added state. */
  function showAdded(btn) {
    if (!btn) return;
    var label = btn.querySelector('[data-ph-add-label]') || btn.querySelector('[data-ph-sticky-label]');
    var done = btn.querySelector('[data-ph-add-done]');
    if (!label || !done) return;
    if (reduce || !window.gsap) {
      btn.setAttribute('data-added', 'true');
      setTimeout(function () { btn.removeAttribute('data-added'); }, 1400);
      return;
    }
    var G = window.gsap;
    G.killTweensOf([label, done]);
    G.set(label, { yPercent: 0, autoAlpha: 1 });
    G.set(done, { yPercent: 130, autoAlpha: 0 });
    var tl = G.timeline();
    tl.to(label, { yPercent: -130, autoAlpha: 0, duration: 0.22, ease: 'power2.in' }, 0);
    tl.to(done, { yPercent: 0, autoAlpha: 1, duration: 0.3, ease: 'back.out(1.7)' }, 0.12);
    tl.to(done, { yPercent: -130, autoAlpha: 0, duration: 0.22, ease: 'power2.in' }, '+=1.1');
    tl.fromTo(label, { yPercent: 130, autoAlpha: 0 }, { yPercent: 0, autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, '-=0.1');
  }
  function doAdd(trigger) {
    if (!form || adding || !idInput.value || !matchVariant(selectedOptions()) || !matchVariant(selectedOptions()).available) return;
    clampQty();
    var body = new FormData(form);
    adding = true; addError.hidden = true;
    [addBtn, stickyAdd].forEach(function (b) { if (b) b.disabled = true; });
    root.querySelectorAll('[data-ph-option-value]').forEach(function (r) { r.disabled = true; });
    if (addBtn) addBtn.classList.add('is-loading');
    return window.PHCartRequest.request('cart/add.js', body, 'product')
      .then(function () {
        showAdded(trigger || addBtn);
        flyToCart();
        /* A short beat lets the button flip and the fly clone travel, so the
           sequence reads click -> Added -> drawer, not everything at once. */
        if (window.PHCart) { setTimeout(function () { window.PHCart.open(); }, reduce ? 0 : 450); }
        else { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; }
      })
      .catch(function (error) { addError.textContent = error.message || 'We could not confirm the update. Check your cart before trying again.'; addError.hidden = false; })
      .finally(function () { adding = false; root.querySelectorAll('[data-ph-option-value]').forEach(function (r) { r.disabled = false; }); updateVariant(); if (addBtn) addBtn.classList.remove('is-loading'); });
  }
  var adding = false;
  var addError = document.createElement('p'); addError.setAttribute('role', 'alert'); addError.hidden = true;
  if (form) form.appendChild(addError);
  if (form) { form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(addBtn); }); }
  if (stickyAdd) stickyAdd.addEventListener('click', function () { doAdd(stickyAdd); });

  /* ---------- Price-talk inline reveal ---------- */
  var nudge = root.querySelector('[data-ph-nudge]');
  if (nudge) {
    var nudgeBtn = nudge.querySelector('[data-ph-nudge-toggle]');
    if (nudge.classList.contains('is-open')) nudgeBtn.setAttribute('aria-expanded', 'true');
    nudgeBtn.addEventListener('click', function () {
      var open = nudge.classList.toggle('is-open');
      nudgeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = nudge.querySelector('.ph-nudge__inner input, .ph-nudge__inner textarea');
        if (first) setTimeout(function () { first.focus({ preventScroll: false }); }, 200);
      }
    });
  }

  /* ---------- Spec accordion (animated disclosure) ----------
     Same technique as the price-nudge reveal: a JS-driven open state animating
     grid-template-rows, not native <details>. Panels render open (so content is
     readable with no JS); here we collapse the non-default ones. Each panel
     toggles independently, so multiple can be open at once, matching the prior
     <details> behaviour. Transitions are suppressed during this initial collapse
     so it does not animate on load. */
  var specsGroup = root.querySelector('[data-ph-specs-group]');
  if (specsGroup) {
    specsGroup.classList.add('ph-specs--preinit');
    var specPanels = specsGroup.querySelectorAll('[data-ph-specs]');
    Array.prototype.forEach.call(specPanels, function (panel) {
      var toggle = panel.querySelector('[data-ph-specs-toggle]');
      if (!toggle) return;
      var openByDefault = panel.hasAttribute('data-ph-specs-open');
      if (!openByDefault) panel.classList.add('is-collapsed');
      toggle.setAttribute('aria-expanded', openByDefault ? 'true' : 'false');
      toggle.addEventListener('click', function () {
        var collapsed = panel.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });
    /* Commit the collapsed state without a transition, then re-enable animation. */
    void specsGroup.offsetHeight;
    specsGroup.classList.remove('ph-specs--preinit');
  }

  /* ---------- Sticky mobile bar ---------- */
  var sticky = root.querySelector('[data-ph-sticky]');
  var actions = root.querySelector('.ph-buybox__actions');
  if (sticky && actions && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var so = new IntersectionObserver(function (entries) { entries.forEach(function (en) { sticky.setAttribute('data-shown', en.isIntersecting ? 'false' : 'true'); }); }, { rootMargin: '0px 0px -60% 0px' });
    so.observe(actions);
  }

  updateVariant();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-info-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ph-info]');
  if (!root) return;
  var body = root.querySelector('.ph-info__body');
  var toc = root.querySelector('[data-ph-toc]');
  if (!body || !toc) return;

  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (heads.length < 2) { toc.style.display = 'none'; return; }

  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  var ul = document.createElement('ul');
  var byId = {};
  heads.forEach(function (h) {
    if (!h.id) h.id = slug(h.textContent) || ('s-' + Math.abs(h.textContent.length));
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    a.setAttribute('data-toc', h.id);
    var li = document.createElement('li');
    li.appendChild(a);
    ul.appendChild(li);
    byId[h.id] = a;
  });
  toc.appendChild(ul);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OFFSET = 108;
  function goTo(id, smooth) {
    var el = document.getElementById(id);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
  }
  ul.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-toc]');
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute('data-toc');
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    goTo(id, true);
  });

  // Deep-link from a PDP badge (or a reload with a hash): land the section at the
  // top with the header offset, overriding the browser's default anchor jump.
  if (window.location.hash && byId[window.location.hash.slice(1)]) {
    var target = window.location.hash.slice(1);
    setTimeout(function () { goTo(target, false); }, 40);
  }

  // Scroll-spy: highlight the section currently in view.
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          Object.keys(byId).forEach(function (k) { byId[k].classList.remove('is-active'); });
          if (byId[en.target.id]) byId[en.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-108px 0px -68% 0px', threshold: 0 });
    heads.forEach(function (h) { obs.observe(h); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-rich-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rp]');
  if (!root) return;
  var jump = root.querySelector('[data-rp-jump]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function navOffset() { return (jump ? jump.getBoundingClientRect().height : 0) + 16; }
  function scrollToId(id, smooth) {
    var el = document.getElementById(id);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - navOffset();
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
  }

  // Smooth in-page anchor scrolling for the jump-nav, hero, and CTA buttons.
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id || !document.getElementById(id)) return;
    e.preventDefault();
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    scrollToId(id, true);
  });

  // Deep-link on load (for example a PDP badge to /pages/warranty#hybrid): land
  // the section below the sticky nav instead of under it.
  if (window.location.hash) {
    var h = window.location.hash.slice(1);
    if (document.getElementById(h)) setTimeout(function () { scrollToId(h, false); }, 40);
  }

  // Scroll-spy: highlight the section currently in view in the jump-nav.
  if (jump && 'IntersectionObserver' in window) {
    var links = Array.prototype.slice.call(jump.querySelectorAll('a[data-rp-nav]'));
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('data-rp-nav')] = a; });
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('data-rp-nav')); }).filter(Boolean);
    if (targets.length) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('is-on'); });
            if (byId[e.target.id]) byId[e.target.id].classList.add('is-on');
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      targets.forEach(function (t) { obs.observe(t); });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-teaser"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Distinct homepage moment: real parallax depth. The lifestyle image drifts
     within its frame as you scroll through the band (scrubbed), while the media
     and copy enter from two converging directions rather than a single fade-up.
     Gated by reduced-motion and by GSAP/ScrollTrigger; base state is visible. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !window.gsap || !window.ScrollTrigger) return;
  var gsap = window.gsap, ST = window.ScrollTrigger;
  gsap.registerPlugin(ST);

  document.querySelectorAll('.ph-wellness').forEach(function (section) {
    var media = section.querySelector('.ph-wellness__media');
    var body = section.querySelector('.ph-wellness__body');
    var img = section.querySelector('img.ph-wellness__img');
    var reversed = section.classList.contains('ph-wellness--reverse');

    if (media) gsap.set(media, { opacity: 0, y: 42, scale: 0.97 });
    if (body) gsap.set(body, { opacity: 0, x: reversed ? -46 : 46 });

    var tl = gsap.timeline({ scrollTrigger: { trigger: section, start: 'top 76%', once: true } });
    if (media) tl.to(media, { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: 'power3.out' });
    if (body) tl.to(body, { opacity: 1, x: 0, duration: 0.8, ease: 'power3.out' }, '-=0.55');

    /* Parallax scrub: oversize the image so the drift never bares an edge. */
    if (img) {
      gsap.set(img, { scale: 1.16, transformOrigin: '50% 50%' });
      gsap.fromTo(img, { yPercent: -7 }, {
        yPercent: 7,
        ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-pureheat"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Distinct homepage moment: the value-prop pillars visibly BUILD in with
     depth and a staggered settle, instead of the uniform .ph-reveal fade-up.
     Fully gated by reduced-motion and by GSAP/ScrollTrigger being present;
     if either is off the markup is already in its natural visible state. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !window.gsap || !window.ScrollTrigger) return;
  var gsap = window.gsap, ST = window.ScrollTrigger;
  gsap.registerPlugin(ST);

  document.querySelectorAll('.ph-why').forEach(function (section) {
    var head = section.querySelectorAll('.ph-why__anim');
    var pillars = section.querySelectorAll('.ph-why__pillar');
    var icons = section.querySelectorAll('.ph-why__icon');
    if (!pillars.length) return;

    gsap.set(head, { opacity: 0, y: 22 });
    gsap.set(pillars, { opacity: 0, y: 44, scale: 0.965 });
    gsap.set(icons, { scale: 0.72, rotate: -8, transformOrigin: '50% 50%' });

    gsap.timeline({ scrollTrigger: { trigger: section, start: 'top 74%', once: true } })
      .to(head, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out', stagger: 0.08 })
      .to(pillars, { opacity: 1, y: 0, scale: 1, duration: 0.75, ease: 'power3.out', stagger: 0.15 }, '-=0.22')
      .to(icons, { scale: 1, rotate: 0, duration: 0.6, ease: 'back.out(1.7)', stagger: 0.15 }, '<0.12');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wif-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function loadWif3D(url) {
    if (window.PHWif3D && typeof window.PHWif3D.create === 'function') return Promise.resolve(window.PHWif3D);
    if (window.__phWif3DModulePromise) return window.__phWif3DModulePromise;
    window.__phWif3DModulePromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = url;
      script.onload = function () {
        if (window.PHWif3D && typeof window.PHWif3D.create === 'function') resolve(window.PHWif3D);
        else reject(new Error('3D module did not register.'));
      };
      script.onerror = function () { script.remove(); reject(new Error('3D module could not load.')); };
      document.head.appendChild(script);
    }).catch(function (error) { window.__phWif3DModulePromise = null; throw error; });
    return window.__phWif3DModulePromise;
  }
  function initWif3d(root) {
    if (root.dataset.wif3dInitialized === 'true') return;
    root.dataset.wif3dInitialized = 'true';
    var host = root.querySelector('[data-wif3d-host]');
    var fallback = root.querySelector('[data-wif3d-fallback]');
    var wif = null, started = false, destroyed = false, io = null;

    function onSectionUnload(event) {
      if (!event.target.contains(root)) return;
      destroyed = true;
      if (io) io.disconnect();
      if (wif) { wif.dispose(); wif = null; }
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);

    function specFromOption(o) {
      return {
        w: +o.dataset.w, d: +o.dataset.d, h: +o.dataset.h,
        body: o.dataset.body, finish: o.dataset.finish,
        feat: {
          front: o.dataset.front || 'door',
          sideWindows: o.dataset.sw === '1',
          roof: o.dataset.roof || 'flat',
          heater: o.dataset.heater || 'visible'
        }
      };
    }

    function boot() {
      if (started || destroyed) return; started = true;
      // Capability gate: leave the fallback if WebGL2 is unavailable.
      var gl = null;
      try { gl = document.createElement('canvas').getContext('webgl2'); } catch (e) {}
      if (!gl) { if (fallback) fallback.querySelector('p').textContent = 'Your device does not support the 3D view.'; return; }

      loadWif3D(root.getAttribute('data-wif3d-module')).then(function (mod) {
        if (destroyed) return;
        if (fallback) fallback.remove();
        var sel = root.querySelector('[data-wif3d-select]');
        if (!sel || !sel.options.length) { console.warn('[wif3d] no catalog options'); return; }
        wif = mod.create(host, { product: specFromOption(sel.options[sel.selectedIndex]), room: { w: 120, d: 120, h: 96 }, scene: 'indoor' });
        sel.addEventListener('change', function () {
          wif.setProduct(specFromOption(sel.options[sel.selectedIndex]));
          wif.reveal();
        });
        var sceneChips = root.querySelectorAll('[data-wif3d-scene]');
        sceneChips.forEach(function (b) {
          b.addEventListener('click', function () {
            sceneChips.forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            wif.setScene(b.dataset.wif3dScene);
          });
        });
        var figBtn = root.querySelector('[data-wif3d-figure]');
        if (figBtn) figBtn.addEventListener('click', function () {
          var on = figBtn.getAttribute('aria-pressed') !== 'true';
          figBtn.setAttribute('aria-pressed', String(on));
          figBtn.classList.toggle('is-active', on);
          wif.setFigure(on);
        });
      }).catch(function (err) {
        if (destroyed) return;
        if (fallback) fallback.querySelector('p').textContent = 'The 3D view could not load.';
        console.error('[wif3d]', err);
      });
    }

    // Lazy-load on approach so this never blocks first paint.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); boot(); }
      }, { rootMargin: '250px' });
      io.observe(host);
    } else { boot(); }
  }
  function initWithin(target) {
      if (target.matches && target.matches('[data-wif3d]')) initWif3d(target);
      if (target.querySelectorAll) target.querySelectorAll('[data-wif3d]').forEach(initWif3d);
  }
  initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["will-it-fit-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWifp(root) {
  if (root.dataset.wifpInitialized === 'true') return;
  root.dataset.wifpInitialized = 'true';
  var listeners = new AbortController(), rt;
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target.contains(root)) return;
    listeners.abort();
    clearTimeout(rt);
    delete root.dataset.wifpInitialized;
  }, { signal: listeners.signal });
  var w = root.querySelector('[data-wifp-w]'), d = root.querySelector('[data-wifp-d]'), h = root.querySelector('[data-wifp-h]');
  var countEl = root.querySelector('[data-wifp-count]');
  var cv = root.querySelector('[data-wifp-canvas]');
  var searchBlock = root.querySelector('.wifp__search-block'), searchInput = root.querySelector('[data-wifp-search]'), searchResults = root.querySelector('[data-wifp-search-results]');
  var selBlock = root.querySelector('[data-wifp-selected]'), selName = root.querySelector('[data-wifp-sel-name]'), selFit = root.querySelector('[data-wifp-sel-fit]'), shopBtn = root.querySelector('[data-wifp-shop]'), vizNote = root.querySelector('[data-wifp-viz-note]');

  var UNITS = { ft: { toIn: 12, dp: 1, step: 0.5, label: 'ft' }, in: { toIn: 1, dp: 0, step: 1, label: 'in' }, m: { toIn: 39.3700787, dp: 2, step: 0.1, label: 'm' } };
  var unit = 'ft';

  var products = [];
  try { products = JSON.parse(root.querySelector('[data-wifp-products]').textContent); } catch (e) { products = []; }
  products = products.map(function (p) {
    Object.assign(p, PHGuidance.fitProduct(p.fit, null));
    p.pm = p.variantPrice || '';
    p.ty = p.ty || 'cabinet';
    p.wd = (p.wd === 'cedar' || p.wd === 'dark') ? p.wd : 'hemlock';
    return p;
  });

  var wif = window.PHWif ? window.PHWif.create(cv) : null;
  var selectedHd = '', scene = 'indoor', pos = { x: 0, y: 0 };

  function toInches(el) { var v = parseFloat(el.value); return (isNaN(v) || v <= 0) ? null : v * UNITS[unit].toIn; }
  function fromDisp(inches) { return (inches / UNITS[unit].toIn).toFixed(UNITS[unit].dp).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1'); }
  function fmtDim(inches) { return fromDisp(inches) + ' ' + UNITS[unit].label; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function byArea(a, b) { return (a.w && a.d ? a.w * a.d : Infinity) - (b.w && b.d ? b.w * b.d : Infinity); }
  function findHd(hd) { for (var i = 0; i < products.length; i++) if (products[i].hd === hd) return products[i]; return null; }
  // Match the active fit tool's planning allowance and uncertainty rule.
  function classify(p, r) {
    if (p.needsReview || ![p.w, p.d, p.h].every(PHGuidance.positive)) return 'verify';
    var ew = p.w + 4, ed = p.d + 4, eh = p.h + 4;
    if (eh > r.h) return 'tall';
    if (ew <= r.w && ed <= r.d) return Math.min(r.w - ew, r.d - ed, r.h - eh) < 3 ? 'tight' : 'fits';
    if (ed <= r.w && ew <= r.d) return Math.min(r.w - ed, r.d - ew, r.h - eh) < 3 ? 'tight-rot' : 'rot';
    return 'no';
  }
  function fits(st) { return st === 'fits' || st === 'rot' || st === 'tight' || st === 'tight-rot'; }
  function drawClass(st) { return st === 'tight' ? 'fits' : st === 'tight-rot' ? 'rot' : st; }
  function rank(st) { return fits(st) ? 0 : st === 'tall' ? 1 : st === 'no' ? 2 : 3; }
  function currentRoom() { var rw = toInches(w), rd = toInches(d), rh = toInches(h); return (rw && rd && rh) ? { w: rw, d: rd, h: rh } : null; }

  function miniCardHTML(p, st) {
    var fc = st === 'fits' ? 'wifp__card-fit--fits' : fits(st) ? 'wifp__card-fit--rot' : 'wifp__card-fit--tall';
    var ft = st === 'fits' ? 'Fits' : st === 'rot' ? 'Fits rotated' : st === 'tight' || st === 'tight-rot' ? 'Tight fit' : st === 'tall' ? 'Too tall' : st === 'verify' ? 'Verify specs' : 'Too big';
    var img = p.img ? '<img class="wifp__mini-img" src="' + esc(p.img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="wifp__mini-img"></span>';
    return '<button type="button" class="wifp__mini' + (p.hd === selectedHd ? ' is-selected' : '') + '" data-hd="' + esc(p.hd) + '" role="option">' + img + '<span class="wifp__mini-body"><span class="wifp__mini-title">' + esc(p.t) + '</span><span class="wifp__mini-meta"><span class="wifp__card-fit ' + fc + '">' + ft + '</span>' + (p.pm ? ' &middot; ' + esc(p.pm) : '') + (p.variantAvailable === false ? ' &middot; Unavailable' : '') + '</span></span></button>';
  }
  function fitLabel(st, r, p) {
    if (st === 'verify') return 'Fit not confirmed: listed dimensions are missing or conflicting. Verify this configuration before ordering.';
    if (st === 'fits') return 'Fits with ' + fmtDim(r.h - p.h - 4) + ' above after our clearance allowance.';
    if (st === 'rot') return 'Fits if rotated a quarter turn, with our clearance allowance.';
    if (st === 'tight' || st === 'tight-rot') return 'Tight fit' + (st === 'tight-rot' ? ' when rotated' : '') + '. Less than ' + fmtDim(3) + ' remains after our clearance allowance; verify installation requirements.';
    if (st === 'tall') return 'Needs ' + fmtDim(p.h + 4 - r.h) + ' more ceiling height after our clearance allowance.';
    return 'Larger than this room floor after our clearance allowance.';
  }
  function highlightSelected() { root.querySelectorAll('.wifp__mini').forEach(function (c) { c.classList.toggle('is-selected', c.getAttribute('data-hd') === selectedHd); }); }

  function renderSearch() {
    if (!searchInput) return;
    var q = (searchInput.value || '').trim().toLowerCase();
    if (!q) { searchResults.hidden = true; searchResults.innerHTML = ''; return; }
    var r = currentRoom() || { w: 96, d: 96, h: 96 };
    var matches = products.filter(function (p) { return p.t.toLowerCase().indexOf(q) >= 0; }).sort(function (a, b) { return rank(classify(a, r)) - rank(classify(b, r)) || byArea(a, b); }).slice(0, 8);
    searchResults.innerHTML = matches.length ? matches.map(function (p) { return miniCardHTML(p, classify(p, r)); }).join('') : '<p class="wifp__none" style="padding:10px 12px;">No models match that search.</p>';
    searchResults.hidden = false;
  }

  function preview(p, r, doSwoosh) {
    if (!p) return;
    selectedHd = p.hd;
    var st = classify(p, r);
    if (wif) {
      if (st === 'verify') wif.clear();
      else if (doSwoosh) wif.swoosh(r, p, drawClass(st), fmtDim, scene, pos);
      else wif.draw(r, p, drawClass(st), fmtDim, scene, pos);
    }
    selName.textContent = p.t; selFit.textContent = fitLabel(st, r, p);
    if (shopBtn) { shopBtn.href = p.u; shopBtn.textContent = 'Shop the ' + p.t.split(',')[0]; }
    selBlock.hidden = false;
    if (vizNote) { vizNote.hidden = false; vizNote.textContent = st === 'verify' ? 'The room preview is unavailable until these dimensions are verified.' : (scene === 'outdoor') ? 'Drag the sauna to place it on the deck.' : 'Drag the sauna to place it where it will sit.'; }
    highlightSelected();
  }

  function recompute(doSwoosh) {
    var r = currentRoom();
    var fitCount = 0; if (r) products.forEach(function (p) { if (fits(classify(p, r))) fitCount++; });
    if (!r) { countEl.innerHTML = 'Enter your width, depth, and ceiling to see what fits.'; selBlock.hidden = true; if (vizNote) { vizNote.hidden = false; vizNote.textContent = 'Enter your room, or search a model, to see it rendered to scale here.'; } if (wif) wif.clear(); return; }
    countEl.innerHTML = '<strong>' + fitCount + '</strong> of ' + products.length + ' saunas fit your space';
    if (searchResults && !searchResults.hidden) renderSearch();
    var pool = products.filter(function (p) { return fits(classify(p, r)); }).sort(byArea);
    if (!pool.length) pool = products.filter(function (p) { return classify(p, r) !== 'verify'; }).sort(byArea);
    if (!pool.length) pool = products.slice().sort(byArea);
    var sel = (selectedHd ? findHd(selectedHd) : null) || pool[0];
    preview(sel, r, doSwoosh !== false);
  }

  // ---- unit + inputs + presets + scene ----
  function relabelUnits() { root.querySelectorAll('[data-wifp-unit-label]').forEach(function (n) { n.textContent = UNITS[unit].label; }); [w, d, h].forEach(function (el) { if (el) el.step = UNITS[unit].step; }); }
  root.querySelectorAll('[data-wifp-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var prev = unit, nu = b.getAttribute('data-wifp-unit'); if (nu === prev) return;
      [w, d, h].forEach(function (el) { if (!el) return; var v = parseFloat(el.value); if (!isNaN(v) && v > 0) { var inches = v * UNITS[prev].toIn; el.value = (inches / UNITS[nu].toIn).toFixed(UNITS[nu].dp).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1'); } });
      unit = nu; root.querySelectorAll('[data-wifp-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      relabelUnits(); recompute(false);
    }, { signal: listeners.signal });
  });
  function setPreset(btn) { var p = btn.getAttribute('data-wifp-preset').split(','); w.value = fromDisp(+p[0]); d.value = fromDisp(+p[1]); if (p[2]) h.value = fromDisp(+p[2]); root.querySelectorAll('[data-wifp-preset]').forEach(function (x) { x.classList.remove('is-active'); }); btn.classList.add('is-active'); recompute(true); }
  root.querySelectorAll('[data-wifp-preset]').forEach(function (b) { b.addEventListener('click', function () { setPreset(b); }, { signal: listeners.signal }); });
  [w, d, h].forEach(function (el) { if (el) el.addEventListener('input', function () { root.querySelectorAll('[data-wifp-preset]').forEach(function (x) { x.classList.remove('is-active'); }); recompute(false); }, { signal: listeners.signal }); });
  if (searchInput) searchInput.addEventListener('input', renderSearch, { signal: listeners.signal });
  if (searchInput) searchInput.addEventListener('focus', function () { if (searchInput.value.trim()) renderSearch(); }, { signal: listeners.signal });
  root.querySelectorAll('[data-wifp-scene]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ns = b.getAttribute('data-wifp-scene'); if (ns === scene) return;
      scene = ns; root.querySelectorAll('[data-wifp-scene]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      if (cv) cv.style.cursor = 'grab';
      var r = currentRoom() || { w: 96, d: 96, h: 96 }, p = selectedHd ? findHd(selectedHd) : null;
      if (p && wif && !p.needsReview) { wif.swoosh(r, p, drawClass(classify(p, r)), fmtDim, scene, pos); if (vizNote) vizNote.textContent = (scene === 'outdoor') ? 'Drag the sauna to place it on the deck.' : 'Drag the sauna to place it where it will sit.'; }
    }, { signal: listeners.signal });
  });
  if (searchResults) searchResults.addEventListener('click', function (e) { var btn = e.target.closest ? e.target.closest('[data-hd]') : null; if (!btn) return; var p = findHd(btn.getAttribute('data-hd')); if (p) { preview(p, currentRoom() || { w: 96, d: 96, h: 96 }, true); searchResults.hidden = true; searchInput.value = ''; } }, { signal: listeners.signal });
  document.addEventListener('click', function (e) { if (searchBlock && searchResults && !searchResults.hidden && !searchBlock.contains(e.target)) searchResults.hidden = true; }, { signal: listeners.signal });

  // ---- drag to place (indoor) ----
  var dragging = false, dragFloor = null, dragPos = null;
  if (cv && wif) {
    cv.addEventListener('pointerdown', function (e) {
      var r = currentRoom(), p = selectedHd ? findHd(selectedHd) : null; if (!r || !p || p.needsReview) return;
      var rect = cv.getBoundingClientRect();
      dragFloor = wif.screenToFloor(e.clientX - rect.left, e.clientY - rect.top);
      dragPos = { x: pos.x, y: pos.y }; dragging = true; cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (err) {}
    }, { signal: listeners.signal });
    cv.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var r = currentRoom(), p = selectedHd ? findHd(selectedHd) : null; if (!r || !p || p.needsReview) return;
      var rect = cv.getBoundingClientRect(), f = wif.screenToFloor(e.clientX - rect.left, e.clientY - rect.top);
      var st = classify(p, r), rot = (st === 'rot' || st === 'tight-rot'), sw = rot ? p.d : p.w, sd = rot ? p.w : p.d;
      pos.x = Math.max(0, Math.min(dragPos.x + (f.x - dragFloor.x), r.w - sw));
      pos.y = Math.max(0, Math.min(dragPos.y + (f.y - dragFloor.y), r.d - sd));
      wif.draw(r, p, drawClass(st), fmtDim, scene, pos);
    }, { signal: listeners.signal });
    function endDrag() { if (dragging) { dragging = false; cv.style.cursor = 'grab'; } }
    cv.addEventListener('pointerup', endDrag, { signal: listeners.signal }); cv.addEventListener('pointercancel', endDrag, { signal: listeners.signal }); cv.addEventListener('pointerleave', endDrag, { signal: listeners.signal });
  }
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (listeners.signal.aborted) return; var r = currentRoom(), p = selectedHd ? findHd(selectedHd) : null; if (r && p && wif && !p.needsReview) wif.draw(r, p, drawClass(classify(p, r)), fmtDim, scene, pos); }, 150); }, { signal: listeners.signal });

  // ---- init: prefill a medium room so the tool is alive on load ----
  relabelUnits();
  if (!w.value) { w.value = '9'; d.value = '9'; h.value = '8'; var mid = root.querySelector('[data-wifp-preset="108,108,96"]'); if (mid) mid.classList.add('is-active'); }
  recompute(true);
  }
  function initWithin(target) {
    if (target.matches && target.matches('[data-wifp]')) initWifp(target);
    if (target.querySelectorAll) target.querySelectorAll('[data-wifp]').forEach(initWifp);
  }
  initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["will-it-fit-tool"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function loadWif3D(url) {
    if (window.PHWif3D && typeof window.PHWif3D.create === 'function') return Promise.resolve(window.PHWif3D);
    if (window.__phWif3DModulePromise) return window.__phWif3DModulePromise;
    window.__phWif3DModulePromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = url;
      script.onload = function () {
        if (window.PHWif3D && typeof window.PHWif3D.create === 'function') resolve(window.PHWif3D);
        else reject(new Error('3D module did not register.'));
      };
      script.onerror = function () { script.remove(); reject(new Error('3D module could not load.')); };
      document.head.appendChild(script);
    }).catch(function (error) { window.__phWif3DModulePromise = null; throw error; });
    return window.__phWif3DModulePromise;
  }
  function initWift(root) {
    if (root.dataset.wiftInitialized === 'true') return;
    root.dataset.wiftInitialized = 'true';
    var destroyed = false, io = null, hintTimer = null;
    function onSectionUnload(event) {
      if (!event.target.contains(root)) return;
      destroyed = true;
      if (io) io.disconnect();
      clearTimeout(hintTimer);
      clearTimeout(deb);
      clearTimeout(searchDeb);
      if (wif) { wif.dispose(); wif = null; }
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);
    var DATA;
    try { DATA = JSON.parse(root.querySelector('[data-wift-data]').textContent); } catch (e) {
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      delete root.dataset.wiftInitialized;
      console.error('[wift] data parse', e);
      return;
    }
    DATA = DATA.map(function(p) { return Object.assign(p, PHGuidance.fitProduct(p.fit, null)); });
    var $ = function (s) { return root.querySelector(s); };
    var els = {
      w: $('[data-wift-w]'), d: $('[data-wift-d]'), h: $('[data-wift-h]'),
      count: $('[data-wift-count]'), countRest: $('[data-wift-count-rest]'),
      list: $('[data-wift-list]'), search: $('[data-wift-search]'),
      browse: $('[data-wift-browse]'), browseSub: $('[data-wift-browse-sub]'), browseCta: $('[data-wift-browse-cta]'),
      fitsOnly: $('[data-wift-fitsonly]'), verdict: $('[data-wift-verdict]'),
      vchip: $('[data-wift-vchip]'), vtext: $('[data-wift-vtext]'), vnums: $('[data-wift-vnums]'), vpanel: $('[data-wift-vpanel]'),
      view: $('[data-wift-view]'), seeall: $('[data-wift-seeall]'),
      canvas: $('[data-wift-canvas]'), poster: $('[data-wift-poster]'), chip: $('[data-wift-canvas-chip]'),
      prev: $('[data-wift-prev]'), next: $('[data-wift-next]'), hint: $('[data-wift-hint]'),
      figure: $('[data-wift-figure]'), sticky: $('[data-wift-sticky]'),
      stext: $('[data-wift-sticky-text]'), scta: $('[data-wift-sticky-cta]'),
      zero: $('[data-wift-zero]'), zeroLede: $('[data-wift-zero-lede]'),
      relaxOutdoor: $('[data-wift-relax-outdoor]'),
      ceilLabel: $('[data-wift-ceil-label]'), ceilHint: $('[data-wift-ceil-hint]'),
      finalH: $('[data-wift-final-h]'), finalCta: $('[data-wift-final-cta]'),
      viewctl: $('[data-wift-viewctl]'), plan: $('[data-wift-plan]'), live: $('[data-wift-live]'),
      planbox: $('[data-wift-planbox]'), caption: $('[data-wift-caption]'),
      spaceleft: $('[data-wift-spaceleft]'), spaceleftText: $('[data-wift-spaceleft-text]'),
    };
    var seeallBase = els.seeall.getAttribute('href');

    // ---- units ----
    var UNITS = { ft: { toIn: 12, dp: 1, label: 'ft' }, in: { toIn: 1, dp: 0, label: 'in' }, cm: { toIn: 1 / 2.54, dp: 0, label: 'cm' } };
    var state = { unit: 'ft', place: 'indoor', w: 120, d: 144, h: 96, sel: null, fitsOnly: true, q: '', placement: 'back-left', view3d: 'room', stageView: 'plan' };
    var GAP = 2; // the 2 in wall gap the sauna sits off the back wall, matching the engine
    function toIn(v) { return v * UNITS[state.unit].toIn; }
    function fromIn(v) { return Number((v / UNITS[state.unit].toIn).toFixed(6)); }
    function fmtIn(v) { return Number((v / UNITS[state.unit].toIn).toFixed(2)) + ' ' + UNITS[state.unit].label; }

    // ---- verdict engine: allowance 2in per side, 4in overhead, tight under 3in ----
    var SIDE = 2, CEIL = 4, TIGHT = 3;
    function outdoorOk(p) {
      return PHGuidance.places(p.loc).includes('outdoor');
    }
    function classify(p, room) {
      if (p.needsReview || ![p.w,p.d,p.h].every(PHGuidance.positive)) return {s:'no',axis:'specification'};
      var ew = p.w + SIDE * 2, ed = p.d + SIDE * 2, eh = p.h + CEIL;
      if (room.h != null && eh > room.h) return { s: 'no', axis: 'height', delta: eh - room.h };
      var hm = room.h != null ? room.h - eh : null;
      if (ew <= room.w && ed <= room.d) {
        var wm = room.w - ew, dm = room.d - ed;
        var m = Math.min(wm, dm, hm == null ? 1e9 : hm);
        return { s: m < TIGHT ? 'tight' : 'fits', wm: wm, dm: dm, hm: hm, rot: false };
      }
      if (ed <= room.w && ew <= room.d) {
        var wm2 = room.w - ed, dm2 = room.d - ew;
        var m2 = Math.min(wm2, dm2, hm == null ? 1e9 : hm);
        return { s: m2 < TIGHT ? 'tight' : 'rot', wm: wm2, dm: dm2, hm: hm, rot: true };
      }
      var direct = {w:Math.max(0,ew-room.w),d:Math.max(0,ed-room.d)};
      var rotated = {w:Math.max(0,ed-room.w),d:Math.max(0,ew-room.d)};
      var best = direct.w+direct.d <= rotated.w+rotated.d ? direct : rotated;
      return {s:'no',axis:best.w >= best.d ? 'width' : 'depth',delta:Math.max(best.w,best.d)};
    }

    function room() { return { w: state.w, d: state.d, h: (state.place === 'outdoor' && state.h == null) ? null : state.h }; }
    function eligible(p) { return PHGuidance.places(p.loc).includes(state.place); }
    function verdictSentence(p, v) {
      if (v.axis === 'specification') return 'Fit not confirmed: listed dimensions are missing or conflicting. Contact us to verify this configuration.';
      if (v.s === 'fits' || v.s === 'rot') {
        var spare = 'with ' + fmtIn(Math.min(v.wm, v.dm)) + ' to spare' + (v.hm != null ? ' and ' + fmtIn(v.hm) + ' at the ceiling' : '');
        return v.s === 'rot' ? 'Fits if rotated 90 degrees, ' + spare + '.' : 'Fits ' + spare + '.';
      }
      if (v.s === 'tight') {
        var lim = Math.min(v.wm, v.dm, v.hm == null ? 1e9 : v.hm);
        var ax = lim === v.hm ? 'of ceiling clearance' : (lim === v.wm ? 'to spare on width' : 'to spare on depth');
        return 'Tight' + (v.rot ? ', rotated 90 degrees' : '') + '. Only ' + fmtIn(lim) + ' ' + ax + ' after our allowance.';
      }
      if (v.axis === 'height') return 'Too tall for your ceiling by ' + fmtIn(v.delta) + '.';
      return 'Needs ' + fmtIn(v.delta) + ' more ' + v.axis + '.';
    }
    var CHIP = { fits: ['Fits', 'wift__badge--fits'], rot: ['Fits rotated', 'wift__badge--rot'], tight: ['Tight', 'wift__badge--tight'], no: ['Does not fit', 'wift__badge--no'] };

    // ---- classification pass ----
    function classifyAll() {
      var r = room();
      return DATA.map(function (p) {
        p = effective(p);
        var el = eligible(p);
        return { p: p, el: el, v: classify(p, r) };
      });
    }
    var ORDER = { fits: 0, rot: 1, tight: 2, no: 3 };
    function sortRows(rows) {
      return rows.slice().sort(function (a, b) {
        var ea = a.el ? 0 : 1, eb = b.el ? 0 : 1;
        if (ea !== eb) return ea - eb;
        var oa = ORDER[a.v.s], ob = ORDER[b.v.s];
        if (oa !== ob) return oa - ob;
        return a.p.t.localeCompare(b.p.t);
      });
    }
    function fitting(rows) { return rows.filter(function (r) { return r.el && r.v.s !== 'no'; }); }

    // ---- render ----
    function capOf(p) { var m = p.t.match(/(\d+)(?:-(\d+))?[- ]Person/i); return m ? (m[2] || m[1]) : ''; }
    // every catalog string that reaches innerHTML goes through here: titles
    // legitimately contain quotes (the "Soria"), and escaping is non-optional
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function render() {
      var valid = [els.w,els.d].every(function(el){return PHGuidance.positive(el.value);}) && (PHGuidance.positive(els.h.value) || (state.place === 'outdoor' && !els.h.value.trim()));
      if (!valid) {
        els.count.textContent = 'Check your measurements'; els.countRest.textContent = ' Enter positive numbers; ceiling height is required indoors.';
        els.list.innerHTML = ''; els.verdict.hidden = true; els.sticky.hidden = true; els.browse.hidden = true; els.plan.innerHTML = ''; els.spaceleft.hidden = true;
        els.canvas.hidden = true; els.finalCta.hidden = true; return;
      }
      els.finalCta.hidden = false;
      els.canvas.hidden = state.stageView !== '3d';
      var rows = classifyAll();
      var fit = fitting(rows);
      els.count.textContent = fit.length + ' of ' + DATA.length;
      els.countRest.textContent = ' meet this planning check. ' + rows.filter(function(r){return r.p.needsReview;}).length + ' need specification confirmation.';

      // picker list
      var q = state.q.toLowerCase();
      var listRows = sortRows(rows).filter(function (r) {
        if (q && (r.p.t + ' ' + r.p.brand).toLowerCase().indexOf(q) === -1) return false;
        if (state.fitsOnly && !(r.el && r.v.s !== 'no')) return false;
        return true;
      });
      els.list.innerHTML = '';
      listRows.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'wift__card' + (state.sel === r.p.hd ? ' is-active' : '');
        b.setAttribute('role', 'option');
        b.setAttribute('data-ph-magnetic', '');
        var chip = r.v.axis === 'specification' ? ['Verify specs', ''] : CHIP[r.v.s];
        b.innerHTML = '<img loading="lazy" alt="" src="' + esc(r.p.img) + '"><span style="min-width:0"><span class="wift__card-name">' + esc(r.p.t) + '</span>' +
          '<span class="wift__card-meta">' + esc(r.p.price) + (capOf(r.p) ? ' | ' + capOf(r.p) + ' person' : '') + ' | ' + r.p.w + ' x ' + r.p.d + ' x ' + r.p.h + ' in</span></span>' +
          '<span class="wift__badge ' + chip[1] + '">' + chip[0] + '</span>';
        b.addEventListener('click', function () { select(r.p.hd, true); });
        els.list.appendChild(b);
      });
      if (!listRows.length) {
        var none = document.createElement('p'); none.className = 'wift__card-meta'; none.style.padding = '8px';
        none.textContent = state.fitsOnly ? 'Nothing fits these filters. Untoggle "Fits my room" to browse all models.' : 'No models match your search.';
        els.list.appendChild(none);
      }

      var sorted = sortRows(rows);

      // Browse handoff: the full "what fits" list lives on the filtered
      // collection, not a long on-page grid. The band echoes the count and
      // links out with the room baked into the URL.
      els.browse.hidden = !fit.length;
      if (fit.length) {
        els.browseSub.textContent = fit.length + ' of ' + DATA.length + ' saunas fit your ' + fmtIn(state.w) + ' by ' + fmtIn(state.d) + (state.place === 'outdoor' ? ' outdoor space' : ' room') + '. Review the matching list above.';
      }

      // zero-fit state
      if (!fit.length) {
        els.zero.hidden = false;
        var minW = Math.min.apply(null, DATA.map(function (p) { return p.w + SIDE * 2; }));
        var minD = Math.min.apply(null, DATA.map(function (p) { return p.d + SIDE * 2; }));
        var binding = state.w < state.d ? 'width of ' + fmtIn(state.w) : 'depth of ' + fmtIn(state.d);
        els.zeroLede.textContent = 'No confirmed match meets the dimensions and placement selected. Review your measurements or contact us about specifications.';
        els.relaxOutdoor.hidden = (state.place === 'outdoor');
      } else { els.zero.hidden = true; }

      // keep a valid selection
      if (!state.sel || !DATA.some(function (p) { return p.hd === state.sel; })) state.sel = (fit[0] || sorted[0]).p.hd;
      renderVerdict(rows);
      renderSticky(fit.length);
      // Collection handoff carries the room in inches + placement so the
      // collection page filters to exactly what fits (fw/fd/fh consumed by
      // the collection fit-filter). room=WxD kept for the legacy filter.
      var ft = function (v) { return Math.round(v / 12 * 10) / 10; };
      var handoff = '#wift-model-list';
      els.seeall.href = handoff; els.seeall.textContent = 'See all ' + fit.length + ' that fit';
      els.finalCta.href = handoff;
      els.browseCta.href = handoff; els.browseCta.textContent = 'See the ' + fit.length + ' saunas that fit';
      writeUrl();
      if (wif) syncScene();
    }

    function effective(p) {
      return Object.assign({}, p, PHGuidance.fitProduct(p.fit, state.sel === p.hd ? state.variant : null));
    }
    function current() {
      var p = DATA.find(function(p) { return p.hd === state.sel; });
      return p ? effective(p) : null;
    }
    function pdpUrl(p) {
      return p.u + '?variant=' + encodeURIComponent(p.variant || '') + '&w=' + fromIn(state.w) + '&d=' + fromIn(state.d) + (state.h != null ? '&h=' + fromIn(state.h) : '') + '&unit=' + state.unit + '&placement=' + state.place;
    }
    // effective footprint inches (swapped when the verdict is fits-rotated)
    function footprintIn(p, v) {
      var rot = !!(v && v.rot);
      return { w: rot ? p.d : p.w, d: rot ? p.w : p.d, rot: rot };
    }
    function placeLabel() {
      return state.placement === 'back-right' ? 'the right corner'
        : state.placement === 'back-center' ? 'the middle of the back wall'
        : 'the left corner';
    }
    function placeLead() {
      return state.placement === 'back-right' ? 'In the right corner'
        : state.placement === 'back-center' ? 'Along the back wall'
        : 'In the left corner';
    }
    // Plain-language "how much floor is left" from the same room/product/
    // placement/rotation state the plan and 3D use, so numbers never disagree.
    function renderSpaceLeft(p, v, eligibleModel) {
      if (!p || v.s === 'no' || !eligibleModel) { els.spaceleft.hidden = true; return; }
      var f = footprintIn(p, v);
      var frontDepth = Math.max(0, state.d - GAP - f.d);
      var side;
      if (state.placement === 'back-center') side = Math.max(0, (state.w - f.w) / 2);
      else side = Math.max(0, state.w - GAP - f.w);
      var tight = Math.min(v.wm, v.dm, v.hm == null ? 1e9 : v.hm);
      var txt = placeLead() + (f.rot ? ', turned 90 degrees,' : '') +
        ' it leaves about ' + fmtIn(state.w) + ' by ' + fmtIn(frontDepth) + ' of open floor in front';
      if (side > 6) txt += ', plus ' + fmtIn(side) + (state.placement === 'back-center' ? ' to each side' : ' to one side');
      txt += '. Tightest gap after our clearance: ' + fmtIn(tight) + '.';
      els.spaceleftText.textContent = txt;
      els.spaceleft.hidden = false;
    }
    // Top-down SVG plan, drawn to the same scale as the fit math. Back wall at
    // the top, open floor toward the viewer (matching the 3D camera).
    function renderPlan(p, v) {
      if (!els.plan || !p) { return; }
      var W = state.w, D = state.d, f = footprintIn(p, v);
      var place = state.placement;
      var sx0 = place === 'back-right' ? (W - GAP - f.w) : place === 'back-center' ? ((W - f.w) / 2) : GAP;
      var sz0 = GAP;
      // content bounds so an oversized (does-not-fit) sauna still shows fully
      var maxX = Math.max(W, sx0 + f.w, 1), maxZ = Math.max(D, sz0 + f.d, 1);
      var drawMax = 300, pad = 30, capPad = 20;
      var s = drawMax / Math.max(maxX, maxZ);
      var rpw = W * s, rpd = D * s;
      var vbw = Math.max(rpw, maxX * s) + pad * 2, vbh = maxZ * s + pad * 2 + capPad;
      var Rx = pad, Ry = pad;
      var Sx = pad + sx0 * s, Sz = pad + sz0 * s, Sw = f.w * s, Sd = f.d * s;
      var Hx = Sx - SIDE * s, Hz = Sz - SIDE * s, Hw = Sw + 2 * SIDE * s, Hd = Sd + 2 * SIDE * s;
      function r(n) { return Math.round(n * 10) / 10; }
      var fits = v.s !== 'no';
      var svg = '<svg viewBox="0 0 ' + r(vbw) + ' ' + r(vbh) + '" xmlns="http://www.w3.org/2000/svg">';
      // room floor
      svg += '<rect x="' + r(Rx) + '" y="' + r(Ry) + '" width="' + r(rpw) + '" height="' + r(rpd) + '" rx="6" fill="#efe4d2" stroke="#8a6a2f" stroke-width="1.5"/>';
      // clearance halo (dashed)
      svg += '<rect x="' + r(Hx) + '" y="' + r(Hz) + '" width="' + r(Hw) + '" height="' + r(Hd) + '" rx="3" fill="none" stroke="#8a6a2f" stroke-width="1" stroke-dasharray="4 3" opacity="0.55"/>';
      // sauna footprint
      svg += '<rect x="' + r(Sx) + '" y="' + r(Sz) + '" width="' + r(Sw) + '" height="' + r(Sd) + '" rx="2" fill="' + (fits ? '#c9a86a' : '#d8b0a2') + '" stroke="' + (fits ? '#8a6a2f' : '#9e2b1a') + '" stroke-width="1.5"/>';
      // footprint dimension label
      svg += '<text x="' + r(Sx + Sw / 2) + '" y="' + r(Sz + Sd / 2 + 4) + '" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" font-weight="600" fill="#15110d">' + p.w + ' x ' + p.d + ' in</text>';
      // room dimension labels
      svg += '<text x="' + r(Rx + rpw / 2) + '" y="' + r(Ry - 9) + '" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" font-weight="600" fill="#675a45">' + fmtIn(W) + '</text>';
      svg += '<text x="' + r(Rx - 9) + '" y="' + r(Ry + rpd / 2) + '" text-anchor="middle" font-family="system-ui,sans-serif" font-size="11" font-weight="600" fill="#675a45" transform="rotate(-90 ' + r(Rx - 9) + ' ' + r(Ry + rpd / 2) + ')">' + fmtIn(D) + '</text>';
      // open-floor caption at the front edge
      svg += '<text x="' + r(Rx + rpw / 2) + '" y="' + r(vbh - 6) + '" text-anchor="middle" font-family="system-ui,sans-serif" font-size="10" letter-spacing="0.06em" fill="#8a6a2f">OPEN FLOOR TOWARD YOU</text>';
      svg += '</svg>';
      els.plan.innerHTML = svg;
      els.plan.setAttribute('aria-label', 'Top-down plan: ' + p.w + ' by ' + p.d + ' inch sauna in ' + placeLabel() + ' of your ' + fmtIn(W) + ' by ' + fmtIn(D) + ' room.');
    }
    function renderVerdict(rows) {
      var p = current(); if (!p) { els.verdict.hidden = true; els.spaceleft.hidden = true; return; }
      var r = rows.filter(function (x) { return x.p.hd === p.hd; })[0];
      var v = r.v, chip = v.axis === 'specification' ? ['Verify specs',''] : CHIP[v.s];
      els.verdict.hidden = false;
      els.vchip.textContent = chip[0]; els.vchip.className = 'wift__vchip wift__badge ' + chip[1];
      els.vtext.textContent = (r.el ? '' : 'This placement is not confirmed in the catalog. ') + verdictSentence(p, v);
      els.vnums.textContent = (p.variantTitle !== 'Default Title' ? p.variantTitle + '. ' : '') + 'Listed sauna: ' + p.w + ' W x ' + p.d + ' D x ' + p.h + ' H in. Your space: ' + fmtIn(state.w) + ' W x ' + fmtIn(state.d) + ' D' + (state.h != null ? ' x ' + fmtIn(state.h) + ' H' : '') + '.';
      if (p.panel) { els.vpanel.hidden = false; els.vpanel.textContent = 'Delivery check: largest panel is ' + p.panel + '.'; }
      else els.vpanel.hidden = true;
      els.view.href = pdpUrl(p); els.view.textContent = 'View the ' + p.t.split(',')[0];
      els.chip.hidden = false;
      els.chip.textContent = chip[0] + (v.s !== 'no' ? ', ' + fmtIn(Math.min(v.wm, v.dm)) + ' spare' : '');
      els.canvas.setAttribute('role', 'img');
      els.canvas.setAttribute('aria-label', '3D preview: ' + p.t + ', ' + p.w + ' by ' + p.d + ' by ' + p.h + ' inches, in your ' + fmtIn(state.w) + ' by ' + fmtIn(state.d) + ' space. ' + verdictSentence(p, v));
      els.finalH.textContent = v.s === 'no' ? 'Check another model or contact us.' : 'Found the one?';
      renderSpaceLeft(p, v, r.el);
      if (p.needsReview) { els.plan.innerHTML = ''; els.poster.querySelector('p').textContent = 'Confirm dimensions before previewing this model.'; els.poster.hidden = false; els.canvas.hidden = true; }
      else { els.poster.hidden = !!wif; renderPlan(p, v); }
    }
    function renderSticky(fitCount) {
      els.sticky.hidden = false;
      var p = current();
      if (!p) { els.stext.textContent = 'Enter your space above.'; els.scta.hidden = true; return; }
      var v = classify(p, room());
      els.scta.hidden = false;
      if (v.s === 'no' || !eligible(p)) {
        els.stext.textContent = (v.axis === 'specification' ? 'Confirm this model’s dimensions. ' : 'This one does not fit. ') + fitCount + ' meet this check.';
        els.scta.textContent = 'See them'; els.scta.href = '#'; els.scta.onclick = function (e) { e.preventDefault(); els.browse.scrollIntoView({ behavior: 'smooth' }); };
      } else {
        els.stext.textContent = CHIP[v.s][0] + '. ' + p.t.split(',')[0] + ', ' + (p.variantPrice || root.getAttribute('data-from-label') + p.price) + (p.variantAvailable === false ? '. ' + root.getAttribute('data-unavailable-label') : '.');
        els.scta.textContent = 'View product'; els.scta.onclick = null; els.scta.href = pdpUrl(p);
      }
    }

    function select(hd, animate) {
      if (state.sel !== hd) state.variant = null;
      state.sel = hd;
      render();
      if (wif && animate) { applyProduct(); wif.reveal(); }
      else if (wif) applyProduct();
    }

    // ---- input wiring ----
    function setFieldValues() {
      els.w.value = fromIn(state.w); els.d.value = fromIn(state.d);
      els.h.value = state.h != null ? fromIn(state.h) : '';
      root.querySelectorAll('[data-wift-unit-label]').forEach(function (n) { n.textContent = UNITS[state.unit].label; });
    }
    var deb;
    function onInput() {
      clearTimeout(deb);
      deb = setTimeout(function () {
        var w = PHGuidance.positive(els.w.value), d = PHGuidance.positive(els.d.value), h = PHGuidance.positive(els.h.value);
        if (w > 0) state.w = toIn(w);
        if (d > 0) state.d = toIn(d);
        state.h = (h > 0) ? toIn(h) : (state.place === 'outdoor' ? null : state.h);
        root.querySelectorAll('[data-wift-preset]').forEach(function (x) { x.classList.remove('is-active'); });
        render();
      }, 400);
    }
    [els.w, els.d, els.h].forEach(function (el) {
      el.addEventListener('input', onInput);
      el.addEventListener('focus', function () { els.sticky.style.display = 'none'; });
      el.addEventListener('blur', function () { els.sticky.style.display = ''; });
    });
    root.querySelectorAll('[data-wift-preset]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-wift-preset').split(',');
        state.w = +v[0]; state.d = +v[1]; state.h = +v[2];
        root.querySelectorAll('[data-wift-preset]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        setFieldValues(); render();
      });
    });
    root.querySelectorAll('[data-wift-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('data-wift-unit') === state.unit) return;
        state.unit = b.getAttribute('data-wift-unit');
        try { localStorage.setItem('wift-unit', state.unit); } catch (e) {}
        root.querySelectorAll('[data-wift-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        setFieldValues(); render();
      });
    });
    root.querySelectorAll('[data-wift-place]').forEach(function (b) {
      b.addEventListener('click', function () { setPlace(b.getAttribute('data-wift-place')); });
    });
    function setPlace(place) {
      state.place = place;
      root.querySelectorAll('[data-wift-place]').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-wift-place') === place); });
      var out = place === 'outdoor';
      els.ceilLabel.textContent = out ? 'Overhead clearance (optional)' : 'Ceiling height';
      els.ceilHint.hidden = !out;
      if (!out && state.h == null) { state.h = 96; setFieldValues(); }
      // a placement change should land on a model that works there, not strand
      // the customer on an indoor-only unit sitting on the outdoor deck
      var p = current();
      if (p && !eligible(p)) {
        var fit = fitting(sortRows(classifyAll()));
        if (fit.length) state.sel = fit[0].p.hd;
      }
      render();
      if (wif) { wif.setScene(out ? 'outdoor' : 'indoor'); applyProduct(); }
    }
    els.relaxOutdoor.addEventListener('click', function () { setPlace('outdoor'); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    var searchDeb;
    els.search.addEventListener('input', function () {
      clearTimeout(searchDeb);
      searchDeb = setTimeout(function () { state.q = els.search.value.trim(); render(); }, 150);
    });
    els.fitsOnly.addEventListener('click', function () {
      state.fitsOnly = !state.fitsOnly;
      els.fitsOnly.classList.toggle('is-active', state.fitsOnly);
      els.fitsOnly.setAttribute('aria-pressed', String(state.fitsOnly));
      render();
    });

    function announce(msg) { if (els.live) els.live.textContent = msg; }
    // placement chooser: rigid seat along the back wall. Re-renders the plan,
    // the space-left metrics and (via applyProduct) the 3D scene from one state.
    root.querySelectorAll('[data-wift-place-pos]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = b.getAttribute('data-wift-place-pos');
        if (pos === state.placement) return;
        state.placement = pos;
        root.querySelectorAll('[data-wift-place-pos]').forEach(function (x) {
          var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on));
        });
        render();
        announce(b.textContent.trim() + ' placement selected');
      });
    });
    // camera view (functional once 3D has loaded; the plan already gives the top-down).
    // data-wift-camview, NOT data-wift-view: the latter is the "View this sauna" CTA link.
    root.querySelectorAll('[data-wift-camview]').forEach(function (b) {
      b.addEventListener('click', function () {
        var vk = b.getAttribute('data-wift-camview');
        state.view3d = vk;
        root.querySelectorAll('[data-wift-camview]').forEach(function (x) {
          var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on));
        });
        if (wif) wif.setView(vk);
        announce(vk === 'top' ? 'Top view selected' : 'Room view selected');
      });
    });

    // ---- URL params ----
    function writeUrl() {
      try {
        var q = new URLSearchParams();
        q.set('w', fromIn(state.w)); q.set('d', fromIn(state.d));
        if (state.h != null) q.set('h', fromIn(state.h));
        q.set('unit', state.unit); q.set('placement', state.place);
        if (state.sel) q.set('product', state.sel);
        if (state.variant) q.set('variant', state.variant);
        history.replaceState(null, '', location.pathname + '?' + q.toString());
      } catch (e) {}
    }
    function readUrl() {
      try {
        var q = new URLSearchParams(location.search);
        if (q.get('unit') && UNITS[q.get('unit')]) state.unit = q.get('unit');
        else { var lu = localStorage.getItem('wift-unit'); if (lu && UNITS[lu]) state.unit = lu; }
        if (q.get('placement') === 'outdoor') state.place = 'outdoor';
        if (PHGuidance.positive(q.get('w'))) state.w = toIn(+q.get('w'));
        if (PHGuidance.positive(q.get('d'))) state.d = toIn(+q.get('d'));
        if (PHGuidance.positive(q.get('h'))) state.h = toIn(+q.get('h'));
        if (q.get('product')) state.sel = q.get('product');
        state.variant = q.get('variant');
        if (state.place === 'outdoor' && !q.has('h')) state.h = null;
      } catch (e) {}
    }

    // ---- 3D integration (lazy; every verdict works before it) ----
    var wif = null;
    function applyProduct() {
      var p = current(); if (!p || p.needsReview || !wif) return;
      // a fits-rotated verdict renders rotated, so the picture and the
      // numbers can never disagree
      var v = classify(p, room());
      wif.setProduct({ w: p.w, d: p.d, h: p.h, body: p.cfg.body, finish: p.cfg.finish, rotate: !!v.rot, placement: state.placement,
        feat: { front: p.cfg.front, sideWindows: p.cfg.sw === 1, roof: p.cfg.roof, heater: p.cfg.heater } });
      syncFigureBtn();
    }
    // the engine hides the figure when the sauna leaves no floor to stand on;
    // the toggle must say so instead of silently doing nothing
    function syncFigureBtn() {
      if (!wif || !wif.figureBlocked) return;
      var blocked = wif.figureBlocked();
      els.figure.disabled = blocked;
      els.figure.title = blocked ? 'No floor space left to stand in this room' : '';
    }
    function syncScene() {
      if (!wif) return;
      wif.setRoom({ w: state.w, d: state.d, h: state.h != null ? state.h : 96 });
      applyProduct();
    }
    function stepModel(dir) {
      var fit = fitting(sortRows(classifyAll()));
      if (!fit.length) return;
      var idx = fit.findIndex(function (r) { return r.p.hd === state.sel; });
      var nx = fit[(idx + dir + fit.length) % fit.length];
      select(nx.p.hd, true);
    }
    els.prev.addEventListener('click', function () { stepModel(-1); });
    els.next.addEventListener('click', function () { stepModel(1); });

    var booting = false;
    function boot3d() {
      if (destroyed || wif || booting) return; // idempotent: the toggle and the observer both call this
      if (!current() || current().needsReview) return;
      booting = true;
      var gl = null;
      try { gl = document.createElement('canvas').getContext('webgl2'); } catch (e) {}
      if (!gl) { booting = false; els.poster.querySelector('p').textContent = 'Your device does not support the 3D preview. The fit results above are complete.'; return; }
      loadWif3D(root.getAttribute('data-wift-scene-module')).then(function (mod) {
        if (destroyed) return;
        var p = current();
        if (!p || p.needsReview) { booting = false; return; }
        wif = mod.create(els.canvas, {
          product: p ? { w: p.w, d: p.d, h: p.h, body: p.cfg.body, finish: p.cfg.finish, rotate: !!classify(p, room()).rot, placement: state.placement, feat: { front: p.cfg.front, sideWindows: p.cfg.sw === 1, roof: p.cfg.roof, heater: p.cfg.heater } } : undefined,
          room: { w: state.w, d: state.d, h: state.h != null ? state.h : 96 },
          scene: state.place === 'outdoor' ? 'outdoor' : 'indoor'
        });
        els.poster.hidden = true;
        els.prev.hidden = false; els.next.hidden = false;
        if (els.viewctl) els.viewctl.hidden = false;
        wif.setFigure(true);
        syncFigureBtn();
        // scroll-trap policy: vertical one-finger drags scroll the page
        var cv = els.canvas.querySelector('canvas');
        if (cv) cv.style.touchAction = 'pan-y';
        // orbit affordance: one dismissible hint, remembered
        var dismissed = false;
        try { dismissed = localStorage.getItem('wift-hint') === '1'; } catch (e) {}
        if (!dismissed && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          hintTimer = setTimeout(function () { if (!dismissed && !destroyed) els.hint.hidden = false; }, 2500);
          els.canvas.addEventListener('pointerdown', function once() {
            dismissed = true; els.hint.hidden = true;
            try { localStorage.setItem('wift-hint', '1'); } catch (e) {}
            els.canvas.removeEventListener('pointerdown', once);
          });
        }
      }).catch(function (err) {
        if (destroyed) return;
        booting = false;
        els.poster.querySelector('p').textContent = 'The 3D preview could not load. The fit results above are complete.';
        console.error('[wift]', err);
      });
    }
    // one stage, two views. The floor plan is always ready (rendered from
    // state); the 3D boots the first time it is shown.
    function setStage(view) {
      state.stageView = view;
      var is3d = view === '3d';
      els.canvas.hidden = !is3d;
      els.planbox.hidden = is3d;
      root.querySelectorAll('[data-wift-stage]').forEach(function (b) {
        var on = b.getAttribute('data-wift-stage') === view;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on));
      });
      if (els.caption) els.caption.textContent = is3d
        ? 'True-to-scale in your room. The figure stands 5 ft 9 in.'
        : 'Top down. The gold outline is the sauna footprint; the shaded floor is what it leaves.';
      if (is3d && wif) wif.resize(); // the canvas had no size while hidden
      announce(is3d ? '3D room view' : 'Floor plan view');
    }
    root.querySelectorAll('[data-wift-stage]').forEach(function (b) {
      b.addEventListener('click', function () {
        var view = b.getAttribute('data-wift-stage');
        setStage(view);
        if (view === '3d') boot3d(); // load on demand when the shopper asks for it
      });
    });
    els.figure.addEventListener('click', function () {
      var on = els.figure.getAttribute('aria-pressed') !== 'true';
      els.figure.setAttribute('aria-pressed', String(on));
      els.figure.classList.toggle('is-active', on);
      if (wif) { wif.setFigure(on); syncFigureBtn(); }
    });

    // ---- init: half-full, never blank ----
    readUrl();
    root.querySelectorAll('[data-wift-unit]').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-wift-unit') === state.unit); });
    if (state.place === 'outdoor') setPlace('outdoor');
    setFieldValues();
    render();
    // Default stage. The verdict, count, picker and handoff all work without
    // 3D, so the floor plan (instant, no Three.js) is the default on a phone
    // (coarse pointer), and the 3D room is the default on desktop. The 3D only
    // boots when its view is on screen (observer) or the shopper toggles to it,
    // so a phone never pays the Three.js main-thread cost unasked.
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    setStage(coarse ? 'plan' : '3d');
    if (!coarse) {
      if ('IntersectionObserver' in window) {
        // the canvas has layout only while the 3D view is active, so the
        // observer fires only for the desktop default, never while on the plan
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); boot3d(); } }, { rootMargin: '300px' });
        io.observe(els.canvas);
      } else boot3d();
    }
  }
  function initWithin(target) {
      if (target.matches && target.matches('[data-wift]')) initWift(target);
      if (target.querySelectorAll) target.querySelectorAll('[data-wift]').forEach(initWift);
  }
  initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
